class TiedProduct extends HTMLElement {
  constructor() {
      super()
      this.colorSwatchesOptions = ["Color","Ribbon color","Ribbon Color","Locket Color","Frame Color","Thread Color"]
      this.builder = this.closest('product-main-builder');
      this.mainProductData = this.builder.productData;
      this.tiedProductData = JSON.parse(this.querySelector('[type="application/json"][data-tied-product-json]').textContent);
      this.tmpVariants = this.tiedProductData.variants;
      this.fakeVariantTitle = this.dataset.fakeVariantTitle;
      this.fakeVariantStartAt = parseInt(this.dataset.fakeVariantStartAt);
      this.mainGallery = this.builder.querySelector('product-gallery');
      this.mainGalleryThumbs = this.builder.querySelector('product-thumbs');
      this.productHandle = this.dataset.productHandle;
      this.mediaLoaded = false;
      this.mediaLoading = false;
      this.hideVariantNameSuffix = this.dataset.hideVariantNameSuffix;
      this.optionBadges = this.mainProductData.option_badges;

      if (this.fakeVariantTitle && this.fakeVariantStartAt) {
        var firstVariant = this.tiedProductData.variants[0];
        var firstVariantOption = firstVariant.option1;
        var fakeVariantId = this.fakeVariantStartAt;
        var fakeVariantTitle = this.fakeVariantTitle;
        this.tiedProductData = {
          ...this.tiedProductData,
          variants: [
            ...this.tiedProductData.variants.map(variant => {
              var mappedVariant = null;
              if (variant.option1 === firstVariantOption) {
                mappedVariant = {
                  ...variant,
                  id: fakeVariantId,
                  option1: this.fakeVariantTitle,
                  title: variant.title.replace(firstVariantOption, fakeVariantTitle),
                  name: variant.name.replace(firstVariantOption, fakeVariantTitle),
                  public_title: variant.public_title.replace(firstVariantOption, fakeVariantTitle),
                  options: variant.title.replace(firstVariantOption, fakeVariantTitle).split('/').map(x => x.trim())
                }
              };
              fakeVariantId = fakeVariantId - 1;
              return mappedVariant
            }).filter(x => x),
            ...this.tiedProductData.variants
          ]
        }
      }

      this.variantInput = this.querySelector('.single-option-selector');
      this.options = this.tiedProductData.options.filter(option=>!this.mainProductData.options.includes(option));
      this.commonOptions = this.tiedProductData.options.filter(option=>this.mainProductData.options.includes(option));
      this.optionValues = {};
      this.label = this.dataset.label;

      this.buildOptionsSelectors();
      this.optionsElements = this.querySelectorAll('[data-option]');
      this.bindOptions();
      this.bindDeferredMediaLoader();

      this.builder.addEventListener('mainVariantChange', (e)=>{

          if(this.tiedProductData.productOptionTied){
            this.toggleComponent(e.detail.variant);
          }

          var variant;
          if(this.mappedForMainVariantId != null && String(this.mappedForMainVariantId) === String(e.detail.variant.id)) {
            // A parent tied product's variantMapping already narrowed, rebuilt and synced this
            // component for this main variant (parents sit earlier in the DOM, so their listener
            // — and its cascade below — runs before ours). Re-running the generic refresh here
            // would look the selection up in the full list, hide the mapped "Set" values and
            // snap the glass back to a non-Set variant.
            variant = this.getCurrentVariant();
          } else {
            // No parent cascade for this main variant: drop any mapping narrowed for the previous
            // shape/size so a stale list can't feed the option builder or the variant lookup.
            this.tmpVariants = this.tiedProductData.variants;
            this.parentMappingActive = false;
            var matchingVariant = this.getMatchingVariant(e.detail.variant);
            var previousVariant = this.getCurrentVariant();
            variant = this.getPreferredMatchingVariant(matchingVariant, previousVariant);

            this.refreshComponent(variant, true);
            if(this.shouldPreserveSelectionsOnMainVariantChange()) {
              this.syncSelectedVariantState(variant);
            }
          }

          // The mapping is keyed by THIS product's variant, i.e. it is shape/size specific, so the
          // chained child has to be re-narrowed for the new main variant (Glass/Floating Paper
          // backings → "Regular Glass Set"/"Art Glass Set") rather than keep the previous one's list.
          if(variant && this.tiedProductData.variantMapping && this.shouldPreserveSelectionsOnMainVariantChange()) {
            this.handleVariantMapping(variant, e.detail.variant.id);
          }

      });
  }

  bindDeferredMediaLoader() {
    if(!this.shouldUseDeferredMediaLoader() || !this.productHandle || this.isGlassOnlyTiedProduct()) return;

    this.addEventListener('focusin', ()=>this.loadDeferredMedia(), { once: true });
    this.addEventListener('mouseenter', ()=>this.loadDeferredMedia(), { once: true });
  }

  shouldUseDeferredMediaLoader() {
    return this.builder && this.builder.dataset.productHandle === 'pressed-frame-1';
  }

  loadDeferredMedia() {
    if(!this.shouldUseDeferredMediaLoader() || this.isGlassOnlyTiedProduct()) return;
    if(this.mediaLoaded || this.mediaLoading || !this.productHandle || !this.mainGallery) return;

    this.mediaLoading = true;
    var rootUrl = window.routes && window.routes.root_url ? window.routes.root_url : '/';
    if(rootUrl.slice(-1) !== '/') {
      rootUrl += '/';
    }

    fetch(rootUrl + 'products/' + this.productHandle + '.js')
      .then(response => {
        if(!response.ok) {
          throw new Error('Unable to load product media');
        }
        return response.json();
      })
      .then(product => {
        this.appendDeferredMedia(product);
        this.mediaLoaded = true;
        this.setAttribute('data-media-loaded', 'true');
      })
      .catch(error => {
        console.warn('Product builder media lazy-load failed', this.productHandle, error);
      })
      .finally(() => {
        this.mediaLoading = false;
      });
  }

  appendDeferredMedia(product) {
    var mediaItems = this.normalizeDeferredMedia(product);
    if(!mediaItems.length) return;

    var galleryWrapper = this.mainGallery.querySelector('.items-wrapper') || this.mainGallery;
    var thumbsWrapper = this.mainGalleryThumbs ? (this.mainGalleryThumbs.querySelector('.items-wrapper') || this.mainGalleryThumbs) : null;
    var mediaAdded = false;

    mediaItems.forEach((media, index) => {
      if(!media || String(media.alt || '').includes('hide')) return;
      if(this.mainGallery.querySelector('[data-media-id="' + media.id + '"]')) return;

      var galleryItem = this.createDeferredGalleryItem(media);
      if(galleryItem) {
        galleryWrapper.appendChild(galleryItem);
        mediaAdded = true;
      }

      if(thumbsWrapper) {
        var thumb = this.createDeferredThumb(media);
        if(thumb) {
          thumbsWrapper.appendChild(thumb);
        }
      }

      if(this.mainProductData.media && !this.mainProductData.media.find(item => String(item.id) === String(media.id))) {
        this.mainProductData.media.push({
          id: media.id,
          alt: media.alt || '',
          media_type: media.media_type || 'image',
          src: media.src,
          preview_src: media.preview_src || media.src
        });
      }
    });

    if(!mediaAdded) return;

    this.mainGallery.dispatchEvent(new CustomEvent('deferredMediaLoaded', { detail: { element: this }}));
    if(this.mainGalleryThumbs) {
      this.mainGalleryThumbs.dispatchEvent(new CustomEvent('deferredMediaLoaded', { detail: { element: this }}));
    }

    if(window.lazySizes && window.lazySizes.loader) {
      window.lazySizes.loader.checkElems();
    }

    this.mainGallery.filterMedia(this.builder.getCurrentVariant(), this.tiedProductsSelectedOptionsValues || []);
    if(this.mainGalleryThumbs) {
      this.mainGalleryThumbs.filterMedia(this.builder.getCurrentVariant(), this.tiedProductsSelectedOptionsValues || []);
    }
  }

  normalizeDeferredMedia(product) {
    if(product.media && product.media.length) {
      return product.media.map((media, index) => {
        var src = media.src || (media.preview_image && media.preview_image.src);
        return {
          id: media.id || (product.id + '-' + index),
          alt: media.alt || '',
          media_type: media.media_type || 'image',
          src: src,
          preview_src: media.preview_image && media.preview_image.src ? media.preview_image.src : src,
          width: media.width || (media.preview_image && media.preview_image.width) || 1600,
          height: media.height || (media.preview_image && media.preview_image.height) || 1600
        };
      }).filter(media => media.src);
    }

    return (product.images || []).map((src, index) => ({
      id: product.id + '-' + index,
      alt: '',
      media_type: 'image',
      src: src,
      preview_src: src,
      width: 1600,
      height: 1600
    }));
  }

  createDeferredGalleryItem(media) {
    if(media.media_type !== 'image') return null;

    var wrap = document.createElement('div');
    wrap.className = 'image-wrap media-wrap';
    wrap.dataset.productId = this.dataset.productId;
    wrap.dataset.mediaId = media.id;
    wrap.dataset.mediaSrc = media.src;
    wrap.style.display = 'none';
    if(media.alt && media.alt.includes(':')) {
      wrap.dataset.filter = media.alt;
    }

    var img = document.createElement('img');
    img.src = this.deferredPlaceholder();
    img.dataset.srcset = this.buildDeferredSrcset(media.src);
    img.dataset.sizes = 'auto';
    img.dataset.file = media.src;
    img.className = 'lazyload';
    img.setAttribute('itemprop', 'image');
    img.alt = media.alt && !media.alt.includes(':') ? media.alt : '';
    img.width = media.width || 1600;
    img.height = media.height || 1600;
    img.loading = 'lazy';
    img.decoding = 'async';

    wrap.appendChild(img);
    return wrap;
  }

  createDeferredThumb(media) {
    var thumb = document.createElement('button');
    thumb.type = 'button';
    thumb.className = 'thumb-wrap';
    thumb.setAttribute('aria-label', media.alt || 'Show image');
    thumb.dataset.productId = this.dataset.productId;
    thumb.dataset.mediaId = media.id;
    thumb.dataset.mediaSrc = media.src;
    thumb.style.display = 'none';
    if(media.alt && media.alt.includes(':')) {
      thumb.dataset.filter = media.alt;
    }

    var img = document.createElement('div');
    img.dataset.bgset = this.buildDeferredSrcset(media.preview_src || media.src, [160, 240, 320]);
    img.className = 'lazyload img';
    img.setAttribute('itemprop', 'image');
    thumb.appendChild(img);

    return thumb;
  }

  buildDeferredSrcset(src, widths=[600, 900, 1200, 1600]) {
    return widths.map(width => $s.imgUrlFilter(src, width + 'x') + ' ' + width + 'w').join(', ');
  }

  deferredPlaceholder() {
    return 'data:image/gif;base64,R0lGODlhAQABAAAAACw=';
  }

  toggleComponent(variant){
    let found = false;
    this.tiedProductData.productOptionTied.forEach(option => {
      if(variant[option.option] && variant[option.option] == option.value){
        found = true;
      }
    });

    if(found){
      this.classList.remove('hide');
      this.querySelectorAll('.step').forEach(step => {
        step.removeAttribute('data-not-required')
        step.classList.remove('no-step');
      });
      this.builder.updateStepsData();
      this.builder.renderTopNav(true);
      this.builder.renderArrows();
      this.querySelectorAll('input[data-name*="items"]').forEach(input => {
        if(input.dataset.name) {
          input.setAttribute('name', input.dataset.name);
          input.removeAttribute('data-name');
        }
      })
      return;
    }
    this.classList.add('hide');
    this.querySelectorAll('input[name*="items"]').forEach(input => {
      input.setAttribute('data-name', input.name);
      input.removeAttribute('name');
    })
    this.querySelectorAll('.step').forEach(step => {
      step.setAttribute('data-not-required', true)
      step.classList.add('no-step');
    });
    this.builder.updateStepsData()
    this.builder.renderTopNav(true);
    this.builder.renderArrows();
  }

  refreshComponent(variant, hideSetOptions){

    this.previousVariant = variant;
    this.setAttribute('data-price', 0);
    var optionValues = this.getOptionValues(variant);
    this.tiedProductData.options.forEach((option, i)=>{
      this.buildOptions(optionValues[i], null, hideSetOptions, option);
    })

    // Resetting selected labels
    this.querySelectorAll('.option-title .option-value, .option-name .option-value').forEach(span => span.innerHTML = '')

    this.querySelectorAll('[type="radio"]').forEach(radio=>{
      var options = ['option1', 'option2', 'option3'];
      var optionNumber = radio.closest('.product-swatch').dataset.option/1;
      var label = radio.parentNode.querySelector('.label-inner');
      var imgOption = options.splice(optionNumber -1, 1);

      var matchingOptionVariant = this.tiedProductData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
      if (!matchingOptionVariant) {
        matchingOptionVariant = this.tiedProductData.variants.find(v=>v[imgOption]==radio.value);
      }

      var img = label.querySelector('img');
      if(img){
        img.remove();
      }
      var oldTileArt = label.querySelector('.tile-art');
      if(oldTileArt){
        oldTileArt.remove();
      }

      if (matchingOptionVariant.featured_image) {
          // Test formatting: larger sources for the bigger tiles, art wrapped so the
          // border hugs the artwork and its baked-in padding can be cropped.
          var testFormatting = this.closest('product-main-builder') && this.closest('product-main-builder').dataset.testFormatting == 'true';
          img = document.createElement('img');
          img.classList.add('swatch-image', 'lazyload');
          img.setAttribute('data-srcset', $s.buildImgSrcset(matchingOptionVariant.featured_image.src, testFormatting ? {width: 180, height: 180} : {width: 50, height: 50}));
          img.setAttribute('alt', matchingOptionVariant.featured_image.alt);
          img.src = $s.imgUrlFilter(matchingOptionVariant.featured_image.src, testFormatting ? '360x' : '80x');
          if (testFormatting) {
            var tileArt = document.createElement('span');
            tileArt.className = 'tile-art';
            tileArt.appendChild(img);
            label.insertAdjacentElement('afterbegin', tileArt);
          } else {
            label.insertAdjacentElement('afterbegin', img);
          }
          label.closest('.swatch').classList.add('image-swatch');
          return;
      }

      label.closest('.swatch').classList.remove('image-swatch');

    });
  }

  connectedCallback() {
    this.setAttribute('data-loaded', 'true'); // Mark as loaded
    this.dispatchEvent(new CustomEvent('childElementLoaded', { bubbles: true, detail: {element: this}}));
  }

  shouldPreserveSelectionsOnMainVariantChange() {
    return this.builder && this.builder.dataset.productHandle === 'pressed-frame-1';
  }

  getPreferredMatchingVariant(matchingVariants, previousVariant) {
    if(!matchingVariants || matchingVariants.length === 0) return null;
    if(!this.shouldPreserveSelectionsOnMainVariantChange() || !previousVariant) return matchingVariants[0];

    // Prefer the variant that matches ALL previously-selected tied options exactly.
    var exact = matchingVariants.find(variant => {
      return this.options.every(optionName => {
        var optionIndex = this.tiedProductData.options.indexOf(optionName);
        if(optionIndex < 0) return true;
        return variant.options[optionIndex] === previousVariant.options[optionIndex];
      });
    });
    if(exact) return exact;

    // No exact match for the whole prior selection. Rather than snapping to an arbitrary
    // first variant (which silently flips a still-valid option like Backing/Glass and moves
    // the price), narrow the candidate set option-by-option, keeping each previously-selected
    // value whenever it is still attainable. Only options that are genuinely unavailable for
    // the new main combination get re-picked.
    var candidates = matchingVariants;
    this.options.forEach(optionName => {
      var optionIndex = this.tiedProductData.options.indexOf(optionName);
      if(optionIndex < 0) return;
      var prevValue = previousVariant.options[optionIndex];
      var kept = candidates.filter(variant => variant.options[optionIndex] === prevValue);
      if(kept.length > 0) candidates = kept;
    });
    return candidates[0];
  }

  syncSelectedVariantState(variant) {
    if(!variant) return;

    this.previousVariant = variant;
    this.variantInput.value = variant.id;
    this.setAttribute('data-price', variant.price || 0);

    this.optionsElements.forEach(element => {
      var optionIndex = Number(element.dataset.option || 1) - 1;
      var value = variant.options[optionIndex];
      element.querySelectorAll('.option-title .option-value, .option-name .option-value').forEach(valueElement => {
        valueElement.innerHTML = value || '';
      });

      element.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = input.value === value;
      });
    });
  }

  getDefaultValueCandidates(defaultValues, optionName) {
    var value = defaultValues ? defaultValues[optionName] : null;
    if(!value) return [];
    return Array.isArray(value) ? value : [value];
  }

  getDefaultSelectionValue(defaultValues, optionName, variants) {
    var optionIndex = this.tiedProductData.options.indexOf(optionName);
    if(optionIndex < 0) return '';

    var candidates = this.getDefaultValueCandidates(defaultValues, optionName);
    if(candidates.length === 0) return '';

    var availableValues = [...new Set((variants || []).map(variant => variant.options[optionIndex]).filter(value => value))];
    return candidates.find(value => availableValues.includes(value)) || '';
  }

  applyDefaultSelection(defaultValues, options = {}) {
    if(!defaultValues || this.classList.contains('hide')) return false;

    var mainVariant = this.builder && typeof this.builder.getCurrentVariant === 'function' ? this.builder.getCurrentVariant() : null;
    if(!mainVariant) return false;

    // When a parent's variantMapping has narrowed this component (e.g. backing "Glass" → the
    // glass "Set" variants) the defaults must be picked from that allowed list, otherwise the
    // full list wins and the non-Set variant is selected/added to cart on initial load.
    var matchingVariants = this.getMatchingVariant(mainVariant, this.parentMappingActive ? this.tmpVariants : null);
    if(!matchingVariants || matchingVariants.length === 0) return false;

    var selectedDefaults = {};
    this.options.forEach((optionName)=>{
      var selectedValue = this.getDefaultSelectionValue(defaultValues, optionName, matchingVariants);
      if(selectedValue) selectedDefaults[optionName] = selectedValue;
    });

    if(Object.keys(selectedDefaults).length === 0) return false;

    var variant = matchingVariants.find(candidate => {
      return Object.keys(selectedDefaults).every(optionName => {
        var optionIndex = this.tiedProductData.options.indexOf(optionName);
        return optionIndex < 0 || candidate.options[optionIndex] === selectedDefaults[optionName];
      });
    }) || matchingVariants[0];

    if(!variant) return false;

    this.dataset.userSelected = 'true';
    this.setAttribute('data-price', variant.price || 0);
    this.refreshComponent(variant, true);
    this.syncSelectedVariantState(variant);
    this.variantChange(variant, false);
    // Defaults are applied in DOM order (parent before child), so cascading here lets the child's
    // own applyDefaultSelection run against the mapped list instead of the full one.
    if(this.tiedProductData.variantMapping) {
      this.handleVariantMapping(variant, mainVariant.id);
    }
    this.tiedProductsSelectedOptionsValues = this.collectBuilderSelectedOptionValues();
    if(options.deferEvents) return true;
    this.builder.dispatchEvent(new CustomEvent('tiedProductVariantChange', {detail: {variant: variant, element: this}}));
    this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
    return true;
  }

  collectBuilderSelectedOptionValues() {
    var tiedProductsSelectedOptionsValues = [];
    this.builder.querySelectorAll('tied-product').forEach((tiedProduct)=>{
      tiedProduct.optionsElements.forEach((el)=>{
        var optionValue = el.querySelector('.option-value');
        if(!optionValue || optionValue.innerHTML=='') {
          return;
        }
        var optionValueText = optionValue.innerHTML.replace(/<span class="additional-price">.*<\/span>/, '').trim();
        if(optionValueText == '') {
          return;
        }
        tiedProductsSelectedOptionsValues.push(el.querySelector('.option-label').innerHTML+optionValueText);
      });
    });

    return tiedProductsSelectedOptionsValues.filter(item => item != '');
  }

  isGlassOnlyTiedProduct() {
    var visualOptionNames = ['Glass', 'Type'];
    var configuredOptions = Array.isArray(this.options) ? this.options : [];
    if(configuredOptions.length > 0) {
      return configuredOptions.every(option => visualOptionNames.includes(String(option || '').trim()));
    }

    var optionLabels = Array.from(this.querySelectorAll('.product-swatch'))
      .map(optionElement => String(optionElement.dataset.label || '').trim());

    return optionLabels.length > 0 && optionLabels.every(option => visualOptionNames.includes(option));
  }

  bindOptions() {
    this.optionsElements.forEach((element)=>{
      element.addEventListener('change', (e)=>{
        this.dataset.userSelected = 'true';
        if(!this.isGlassOnlyTiedProduct()) {
          this.loadDeferredMedia();
        }
        let optionIdx = element.dataset.option-1;
        let variant = this.calculateNewVariant(optionIdx, e.target.value);
        this.setAttribute('data-price', variant.price);
        this.refreshOptions(element.dataset.option-1, variant);
        this.variantChange(variant);

        if(this.tiedProductData.variantMapping){
          var mainVariantForMapping = this.builder.getCurrentVariant();
          this.handleVariantMapping(variant, mainVariantForMapping ? mainVariantForMapping.id : null);
        }

        this.tiedProductsSelectedOptionsValues = this.collectBuilderSelectedOptionValues();
        //console.log(this.tiedProductsSelectedOptionsValues);
        this.builder.dispatchEvent(new CustomEvent('tiedProductVariantChange', {detail: {variant: variant, element: this}}));
        this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
      });
    });
  }

  // Strip the configured hidden suffix ("Set") so "Regular Glass" and "Regular Glass Set" are
  // treated as the same user choice when a mapping swaps one list for the other.
  normalizeOptionValue(value) {
    var normalized = String(value == null ? '' : value).trim();
    var suffix = this.hideVariantNameSuffix ? String(this.hideVariantNameSuffix).trim() : '';
    if(suffix && normalized.length > suffix.length && normalized.slice(-suffix.length) === suffix) {
      normalized = normalized.slice(0, -suffix.length).trim();
    }
    return normalized;
  }

  handleVariantMapping(variant, mainVariantId) {
    var variantMapping = this.tiedProductData.variantMapping[variant.id];
    if(variantMapping) {
      var childTiedComponent = this.builder.querySelector('tied-product[data-product-id="'+variantMapping.productChildId+'"]');
      this.tiedProductChild = childTiedComponent;

      if(!this.tiedProductChild) return;

      // show only variants from the variantMapping.variants
      var childVariants = this.tiedProductChild.tiedProductData.variants.filter((childVariant)=>{
        return (variantMapping.variantsAsObjects) ? variantMapping.variants.find(v => v.id==childVariant.id) : variantMapping.variants.includes(childVariant.id);;
      });

      if(childVariants.length <= 0) return;
      // Preserve the child tied product's current selection when it is still allowed for the
      // new parent variant, instead of always snapping to the first allowed child variant.
      // Match on the child's own (non-shared) option values — e.g. Material / Glass Type — so a
      // still-valid backing like "Black Linen" is kept rather than reset to the first option
      // ("Glass"), which previously dropped the progress bar and changed the price when the user
      // merely toggled Design Style. Falls back to the first allowed variant only when the prior
      // selection is genuinely unavailable for the new parent variant (a legitimate reset).
      var childPrev = (typeof this.tiedProductChild.getCurrentVariant === 'function') ? this.tiedProductChild.getCurrentVariant() : this.tiedProductChild.currentVariant;
      var childMatchesPrev = (cv, normalize)=>{
        return this.tiedProductChild.options.every((optName)=>{
          var oi = this.tiedProductChild.tiedProductData.options.indexOf(optName);
          if(oi < 0) return true;
          return normalize(cv.options[oi]) === normalize(childPrev.options[oi]);
        });
      };
      var childChosen = (childPrev && (
        childVariants.find((cv)=>childMatchesPrev(cv, (v)=>v)) ||
        // "Regular Glass" ↔ "Regular Glass Set": keep the user's glass type across a mapping
        // that swaps the plain list for the "Set" list (or back).
        childVariants.find((cv)=>childMatchesPrev(cv, (v)=>this.tiedProductChild.normalizeOptionValue(v)))
      )) || childVariants[0];
      this.tiedProductChild.currentVariant = childChosen;
      this.tiedProductChild.value = childChosen.id;
      this.tiedProductChild.tmpVariants = childVariants;
      this.tiedProductChild.parentMappingActive = true;
      this.tiedProductChild.mappedForMainVariantId = (mainVariantId != null) ? mainVariantId : null;
      this.tiedProductChild.refreshComponent(childChosen);
      // refreshComponent rebuilds the option buttons UNCHECKED and zeroes the child's price, so
      // without this the child step is left with nothing selected (progress drops, price changes)
      // even when childChosen preserves the prior value. Re-check the chosen radio and restore the
      // price, mirroring the mainVariantChange path at the top of this class.
      if(typeof this.tiedProductChild.shouldPreserveSelectionsOnMainVariantChange === 'function' && this.tiedProductChild.shouldPreserveSelectionsOnMainVariantChange()) {
        this.tiedProductChild.syncSelectedVariantState(childChosen);
      }
      return;
    }
    if(this.tiedProductChild){
      var mainProductVariant = this.builder.getCurrentVariant();
      if(mainProductVariant) {
        var child = this.tiedProductChild;
        // Capture the child's current selection BEFORE the refresh rebuilds it (by id, from the
        // full variant list, so a narrowed tmpVariants from a prior mapping doesn't hide it).
        var prevId = child.variantInput ? child.variantInput.value : null;
        var childPrev = prevId ? child.tiedProductData.variants.find((v)=>String(v.id) === String(prevId)) : null;
        child.tmpVariants = child.tiedProductData.variants;
        child.parentMappingActive = false;
        child.mappedForMainVariantId = null;
        // A parent variant without a tied_variants metafield falls back to the
        // child's full variant list; pass the hide flag so suffix-hidden values
        // (e.g. glass "Set" types) do not appear in that fallback.
        child.refreshComponent(mainProductVariant, true)
        // refreshComponent leaves every radio UNCHECKED, so toggling to a parent value with no
        // mapping (e.g. Design Styles Traditional/Puzzled/Vertical) would wipe the child's
        // still-valid selection — dropping the progress bar and price. Re-check the prior choice
        // when it's still available for the current shape/size, guarded on a visible rendered
        // radio so hidden "Set"-style values aren't force-preserved into an unrelated context.
        if(childPrev && typeof child.shouldPreserveSelectionsOnMainVariantChange === 'function' && child.shouldPreserveSelectionsOnMainVariantChange()) {
          var keep = child.tiedProductData.variants.find((cv)=>{
            var sharedOk = child.commonOptions.every((name)=>{
              var ci = child.tiedProductData.options.indexOf(name);
              var mi = child.mainProductData.options.indexOf(name);
              return ci < 0 || mi < 0 || cv.options[ci] === mainProductVariant.options[mi];
            });
            var uniqueOk = child.options.every((name)=>{
              var ci = child.tiedProductData.options.indexOf(name);
              return ci < 0 || cv.options[ci] === childPrev.options[ci];
            });
            return sharedOk && uniqueOk;
          });
          var keepHasVisibleRadio = keep && [...child.querySelectorAll('input[type="radio"]')].some((r)=>{
            return child.options.some((name)=>{
              var ci = child.tiedProductData.options.indexOf(name);
              return ci >= 0 && String(r.value) === String(keep.options[ci]);
            });
          });
          if(keep && keepHasVisibleRadio) {
            child.currentVariant = keep;
            child.value = keep.id;
            child.syncSelectedVariantState(keep);
          }
        }
      }
    }
  }

  hideMediaFromOtherProducts() {
    if(this.mainGallery) {
      this.mainGallery.querySelectorAll('[data-product-id="'+ this.dataset.productId +'"]').forEach((item)=>{
        item.style.display = 'none';
      });
      if(this.mainGallery.slider) {
        this.mainGallery.slider.refresh();
      }
    }
    if(this.mainGalleryThumbs) {
      this.mainGalleryThumbs.querySelectorAll('[data-product-id="'+ this.dataset.productId +'"]').forEach((item)=>{
        item.style.display = 'none';
      });
      if(this.mainGalleryThumbs.slider) {
        this.mainGalleryThumbs.slider.refresh();
      }
    }
  }

  refreshOptions(updateOptionIndex=-1, currentVariant) {
    var optionValues = this.getOptionValues(currentVariant);
    this.optionsElements.forEach((element)=>{
      let index = element.dataset.option - 1;
      if(index > updateOptionIndex) {
        element.buildOptions(optionValues[index], currentVariant.options[index], true);
      }
      var optionValueElement = element.querySelector('.option-value');
      if(optionValueElement) {
        var optionValue = currentVariant.options[index];
        optionValueElement.innerHTML = optionValue;
      }
    });
  }

  variantChange(variant, animate=true) {
    if(variant) {
      this.variantInput.value = variant.id;
    } else {
      this.variantInput.value = '';
    }
    this.previousVariant = variant;

    this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
  }

  getMatchingVariant(mainProductVariant, pool) {
    var matchingVariants = (pool || this.tiedProductData.variants).filter(v => {
      var matches = 0;
      this.commonOptions.forEach((option, i)=>{
        if(v['option'+(i+1)]==mainProductVariant['option'+(i+1)]) {
          matches++;
          return;
        }
      })
      return matches==this.commonOptions.length;
    })

    return matchingVariants;
  }

  calculateNewVariant(optionChanged, value) {
    // Every variant carrying the option value the user just chose.
    var candidates = this.tmpVariants.filter(x=>x.options[optionChanged]==value);
    if(candidates.length==0) return undefined;

    // Pick the candidate that PRESERVES the most previously-selected sibling option values.
    // This keeps any still-valid sibling (e.g. Glass / Backing) instead of silently flipping
    // it to whatever variant happens to be first; a sibling is only changed when no candidate
    // for the new selection can keep it. The scan is order-independent: the original
    // left-to-right narrowing could falsely drop a still-valid sibling because of option order.
    var prev = this.previousVariant;
    if(!prev) return candidates[0];

    // Weight earlier options more heavily so option priority (option1 > option2 > option3)
    // matches the prior left-to-right behavior: an earlier sibling is preserved in preference
    // to a later one when both cannot be kept at once.
    var numOptions = this.tiedProductData.options.length;
    var bestVariant = candidates[0];
    var bestScore = -1;
    candidates.forEach((candidate)=>{
      var score = 0;
      this.tiedProductData.options.forEach((option, index)=>{
        if(optionChanged==index) return;
        if(candidate.options[index]==prev.options[index]) score += (1 << (numOptions - index));
      });
      if(score > bestScore) {
        bestScore = score;
        bestVariant = candidate;
      }
    });
    return bestVariant;
  }

  buildOptionsSelectors() {

    // Test formatting: the heading shows the live value ("Design Style: Garden") the
    // way main-product options do — the title span precedes the .option-name one, so
    // the existing first-match value writers land on it.
    var testFormatting = this.builder && this.builder.dataset.testFormatting == 'true';

    this.tiedProductData.options.forEach((option, i)=>{
      var optionElement = document.createElement('div');
      var currentVariant = this.getCurrentVariant();
      var optionValues = this.getOptionValues(currentVariant)[i];
      this.setAttribute('aria-labelledby', `tiedproduct-option-${$s.handleize(option)}-${this.builder.sectionId}`);
      optionElement.classList.add('option');

      if(!this.options.includes(option)) {
        return;
      }

      var dropdownField = this.dataset.dropdown === 'true'
        ? `<div class="field tied-dropdown-field">
            <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg>
            <select aria-labelledby="${this.getAttribute('aria-labelledby')}" data-label="${option}" data-tied-dropdown="${$s.handleize(option)}"></select>
          </div>`
        : '';
      optionElement.innerHTML = `
      <div class="product-swatch option-${$s.handleize(option)} step" data-option="${i+1}" data-label="${option}" id="tiedproduct-option-${$s.handleize(option)}-${this.id}">
        <span class="option-title" id="${this.getAttribute('aria-labelledby')}">${this.label}${testFormatting ? ' <span aria-hidden="true" class="option-value"></span>' : ''}</span>
        <div class="flex justify-content-between">
          <div class="option-name">
            <span class="option-label">${option}:</span>
            <span aria-hidden="true" class="option-value"></span>
          </div>
          <div class="swatch-group flex flex-wrap"></div>
          ${dropdownField}
        </div>
      </div>
      `;
      this.appendChild(optionElement);
      this.buildOptions(optionValues, null, true, option);
    });

  }

  shouldHideOptionValue(optionValue, hideSetOptions) {
    // Values carrying the hidden suffix ("Set") only ever surface through a parent's
    // variantMapping; while that mapping is active they ARE the intended list, so never hide them.
    return Boolean(
      hideSetOptions &&
      !this.parentMappingActive &&
      this.hideVariantNameSuffix &&
      String(optionValue || '').indexOf(this.hideVariantNameSuffix) >= 0
    );
  }

  buildOptions(options, defaultValue, hideSetOptions, optionName) {
    if (!options) return;
    var html = '';
    if (options.length > 0) {
      this.setAttribute('role', 'radiogroup');
    }
    var groupOptionName = (options[0] && options[0].name) || optionName;
    if(!groupOptionName || !this.options.includes(groupOptionName)) return;
    options.forEach((option, index)=>{

      if(this.shouldHideOptionValue(option.value, hideSetOptions)){
        return;
      }

      if(!this.options.includes(option.name)) {
        return;
      }

      var optionNameHandle = $s.handleize(option.name);
      var optionValueHandle = $s.handleize(option.value);
      var id = `swatch-${index+1}-${$s.handleize(option.value)}-${this.id}`;
      var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
      var badge = null;

      if(this.optionBadges && this.optionBadges.length > 0) {
        badge = this.optionBadges.find(x=> x.option_name==option.name && x.option_value==option.value);
      }

      html += `
        <div class="swatch" data-available="${option.available}">
          <input type="radio" id="${id}" name="swatch-${optionNameHandle}-${this.id}" value="${$s.escapeDomAttribute(option.value)}" />
          <label for="${id}">
            <div class="label-inner flex align-items-center justify-content-center animation ${optionNameHandle}-${optionValueHandle}">
              <span>${option.value}${soldOut}</span>
              ${(badge && badge.label) ? `<span class="badge" style="--scheme-badges-background: ${badge.background_color};--scheme-badges-label:${badge.text_color};--badge-font-family: var(${badge.font_family}); --badge-font-style: ${badge.font_style}">${badge.label}</span>` : ''}
            </div>
          </label>
        </div>
      `;
    });

    // Written after the loop (and even when every value was filtered out) so a group never keeps
    // stale radios from a previous shape/size or mapping.
    var group = this.querySelector(`#tiedproduct-option-${$s.handleize(groupOptionName)}-${this.id} .swatch-group`);
    if(group) group.innerHTML = html;

    if (this.dataset.dropdown === 'true') {
      this.syncDropdownsFromSwatches();
    }

  }

  // Dropdown mode: the select mirrors the (hidden) radio swatches and proxies every
  // choice back through them, so variantMapping / syncSelectedVariantState / builder
  // step logic all keep working unchanged.
  syncDropdownsFromSwatches() {
    this.querySelectorAll('select[data-tied-dropdown]').forEach((select)=>{
      var group = select.closest('.product-swatch');
      if (!group) return;
      var radios = [...group.querySelectorAll('.swatch-group input[type="radio"]')];
      var checked = radios.find(r=>r.checked);
      var html = checked ? '' : `<option value="" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      radios.forEach((radio)=>{
        html += `<option value="${$s.escapeDomAttribute(radio.value)}"${checked && checked.value===radio.value ? ' selected' : ''}>${radio.value}</option>`;
      });
      select.innerHTML = html;
      if (!select.dataset.bound) {
        select.dataset.bound = 'true';
        select.addEventListener('change', ()=>{
          var target = [...group.querySelectorAll('.swatch-group input[type="radio"]')].find(r=>r.value===select.value);
          if (target && !target.checked) target.click();
          var placeholder = select.querySelector('option[disabled]');
          if (placeholder && select.selectedOptions[0] !== placeholder) placeholder.remove();
        });
        // Keep the select honest when the builder re-checks swatches programmatically
        group.addEventListener('change', (e)=>{
          if (e.target.matches('.swatch-group input[type="radio"]') && e.target.checked && select.value !== e.target.value) {
            var stalePlaceholder = select.querySelector('option[disabled]');
            if (stalePlaceholder) stalePlaceholder.remove();
            select.value = e.target.value;
          }
        });
      }
    });
  }

  getCurrentVariant() {
    // tmpVariants may be narrowed by a parent mapping for a previous shape/size; fall back to the
    // full list so the current selection is never "lost" across a main variant change.
    return this.tmpVariants.find(x=>x.id==this.variantInput.value) || this.tiedProductData.variants.find(x=>x.id==this.variantInput.value);
  }

  getOptionValues(currentVariant) {
    var options = [];
    if (!currentVariant) return options;
    this.tiedProductData.options.forEach((option, index)=>{
      if(index==0) {
        var optionValues = this.tmpVariants.map((variant)=>{return {
          name: this.tiedProductData.options[index],
          value: variant.options[index],
          available: variant.available
        }});
      }
      if(index==1) {
        var optionValues = this.tmpVariants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
          name: this.tiedProductData.options[index],
          value: variant.options[index],
          available: variant.available
        }});
      }
      if(index==2) {
        var optionValues = this.tmpVariants.filter(
          x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
        ).map((variant)=>{return {
          name: this.tiedProductData.options[index],
          value: variant.options[index],
          available: variant.available
        }});
      }
      var optionValuesUnique = [];
      optionValues.forEach((option, key)=>{
        if(!optionValuesUnique.find(x=>x.value==option.value)) {
          if(option.available) {
            optionValuesUnique.push(option);
          } else {
            if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
              optionValuesUnique.push(option);
            }
          }
        }
      });
      options.push(optionValuesUnique);
    });
    return options;
  }

}
customElements.define('tied-product', TiedProduct);

if(!customElements.get('builder-preview-compositor')) {
  class BuilderPreviewCompositor extends HTMLElement {
    constructor() {
      super();
      this.builder = this.closest('product-main-builder');
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas ? this.canvas.getContext('2d') : null;
      this.gallery = this.builder ? this.builder.querySelector('product-gallery') : null;
      this.thumbs = this.builder ? this.builder.querySelector('product-thumbs') : null;
      this.imageCache = new Map();
      this.renderToken = 0;
      this.renderPromise = Promise.resolve();
      this.active = false;
      this.missingRequiredLayers = [];
      this.lastUploadUrl = null;
      this.imageBoundsCache = new WeakMap();
      this.frameOpeningBoundsCache = new WeakMap();
      this.frameRenderCache = new Map();
      this.frameRenderCacheLimit = 4;
      this.primaryGalleryItem = null;
      this.primaryThumbItem = null;
      this.primaryThumbCanvas = null;
      this.dynamicGalleryItems = [];
      this.dynamicThumbItems = [];
      this.hasRenderedAdjacentGallery = false;
      this.manifest = null;
      this.initialized = false;
      this.renderDebounceMs = 35;
      this.renderTransitionStartedAt = 0;
      this.renderTransitionFallback = null;
      this.isRendering = false;
      this.skipNextStepRender = false;
      this.lastFrameTransitionSignature = '';
      this.defaultPreviewSelection = {
        Shape: 'Rectangle',
        Size: '16x20',
        Color: (this.builder && this.builder.dataset.pressedFrameDefaultColor) || 'Walnut Brown',
        Style: 'Traditional',
        Material: 'Glass',
        Type: 'Regular Glass'
      };
      this.valueAliases = {
        'Regular Glass Set': 'Regular Glass',
        'Art Glass Set': 'Art Glass'
      };
    }

    connectedCallback() {
      if(!this.builder || !this.canvas || !this.context) return;

      this.loadManifest().then(manifest => {
        if(!manifest) {
          this.markInitialPreviewReady();
          return;
        }
        this.manifest = manifest;
        this.initialize();
      });
    }

    initialize() {
      if(this.initialized || !this.manifest) return;
      this.initialized = true;
      this.builder.previewCompositor = this;
      this.refreshGalleryRefs();
      this.builder.addEventListener('pointerdown', event => this.primeRenderTransitionForInteraction(event), true);
      this.builder.addEventListener('keydown', event => this.primeRenderTransitionForInteraction(event), true);
      this.builder.addEventListener('pointermove', event => this.abortRenderTransitionIfScrolling(event), { capture: true, passive: true });
      this.builder.addEventListener('pointerup', event => this.releasePrimedRenderPointer(event), true);
      this.builder.addEventListener('pointercancel', event => this.abortRenderTransitionIfScrolling(event, true), true);
      ['variantChange', 'mainVariantChange'].forEach(eventName => {
        this.builder.addEventListener(eventName, () => this.scheduleRender());
      });
      this.builder.addEventListener('tiedProductVariantChange', event => {
        if(this.isGlassOnlyTiedProductElement(event.detail && event.detail.element)) {
          this.skipNextStepRender = true;
          return;
        }
        this.scheduleRender();
      });
      this.builder.addEventListener('stepChange', () => {
        if(this.skipNextStepRender) {
          this.skipNextStepRender = false;
          return;
        }
        this.scheduleRender();
      });
      this.scheduleRender();
    }

    async loadManifest() {
      if(this.dataset.layerManifestUrl) {
        return await this.loadLayerManifest();
      }

      var manifestScript = this.parentNode ? this.parentNode.querySelector('[data-builder-layer-manifest]') : null;
      return this.parseManifestScript(manifestScript);
    }

    parseManifestScript(manifestScript) {
      if(!manifestScript) return null;

      try {
        var parsed = JSON.parse(manifestScript.textContent);
        return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
      } catch(error) {
        console.warn('Builder layer manifest is invalid', error);
        return null;
      }
    }

    loadLayerManifest() {
      if(window.PF_BUILDER_LAYER_MANIFEST_MULTI_SIZE) {
        return Promise.resolve(window.PF_BUILDER_LAYER_MANIFEST_MULTI_SIZE);
      }

      if(window.PF_BUILDER_LAYER_MANIFEST_MULTI_SIZE_PROMISE) {
        return window.PF_BUILDER_LAYER_MANIFEST_MULTI_SIZE_PROMISE;
      }

      window.PF_BUILDER_LAYER_MANIFEST_MULTI_SIZE_PROMISE = new Promise(resolve => {
        var script = document.createElement('script');
        script.src = this.dataset.layerManifestUrl;
        script.async = true;
        script.onload = () => resolve(window.PF_BUILDER_LAYER_MANIFEST_MULTI_SIZE || null);
        script.onerror = () => {
          console.warn('Builder layer manifest failed to load');
          resolve(null);
        };
        document.head.appendChild(script);
      });

      return window.PF_BUILDER_LAYER_MANIFEST_MULTI_SIZE_PROMISE;
    }

    scheduleRender() {
      clearTimeout(this.renderTimeout);
      // A genuine option change now owns the transition; the scroll-abort guard
      // must no longer treat the spinner as a speculative pointerdown flash.
      this.primeIsSpeculative = false;
      this.beginRenderTransition();
      this.renderTimeout = setTimeout(() => {
        this.refreshGalleryRefs();
        this.renderPromise = this.render();
      }, this.renderDebounceMs);
    }

    primeRenderTransitionForInteraction(event) {
      if(event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;

      var target = event.target;
      if(!target || !target.closest) return;

      var optionControl = target.closest('product-variants, product-swatch, tied-product, property-options');
      if(!optionControl || !this.builder.contains(optionControl)) return;
      if(this.isGlassOnlyTiedProductElement(optionControl.closest('tied-product'))) return;

      // Only prime on a genuine activation of an actual control, not a tap that merely
      // lands in the padding/gaps near an option ("make it so the image only loads when
      // you click an option, but not when you click near one").
      if(!target.closest('input, label, button, a, [role="radio"], [role="button"]')) return;

      // Track the touch so a scroll gesture that begins on a tile aborts the speculative
      // spinner (abortRenderTransitionIfScrolling) instead of leaving the preview blanked.
      if(event.type === 'pointerdown') {
        this.primePointerId = event.pointerId;
        this.primePointerStartX = event.clientX;
        this.primePointerStartY = event.clientY;
        this.primeIsSpeculative = true;
      }

      this.beginRenderTransition();
    }

    abortRenderTransitionIfScrolling(event, force) {
      if(this.primePointerId == null) return;
      if(!force && event && event.pointerId !== this.primePointerId) return;
      if(!force && event) {
        var movedX = Math.abs(event.clientX - this.primePointerStartX);
        var movedY = Math.abs(event.clientY - this.primePointerStartY);
        if(movedX <= 10 && movedY <= 10) return;
      }

      // The gesture became a scroll/drag (or was cancelled) and no real option change
      // claimed the transition — drop the speculative spinner immediately.
      this.primePointerId = null;
      if(this.primeIsSpeculative) {
        this.primeIsSpeculative = false;
        this.setRenderingState(false);
      }
    }

    releasePrimedRenderPointer(event) {
      if(this.primePointerId != null && (!event || event.pointerId === this.primePointerId)) {
        this.primePointerId = null;
      }
    }

    isGlassOnlyTiedProductElement(element) {
      if(!element || element.tagName !== 'TIED-PRODUCT') return false;
      var visualOptionNames = ['Glass', 'Type'];
      var configuredOptions = Array.isArray(element.options) ? element.options : [];
      if(configuredOptions.length > 0) {
        return configuredOptions.every(option => visualOptionNames.includes(this.normalizeValue(option)));
      }

      var optionLabels = Array.from(element.querySelectorAll('.product-swatch'))
        .map(optionElement => this.normalizeValue(optionElement.dataset.label));
      return optionLabels.length > 0 && optionLabels.every(option => visualOptionNames.includes(option));
    }

    refreshGalleryRefs() {
      this.gallery = this.builder ? this.builder.querySelector('product-gallery') : null;
      this.thumbs = this.builder ? this.builder.querySelector('product-thumbs') : null;
      this.galleryWrapper = this.gallery ? (this.gallery.querySelector('.items-wrapper') || this.gallery) : null;
      this.thumbsWrapper = this.thumbs ? (this.thumbs.querySelector('.items-wrapper') || this.thumbs) : null;
    }

    getOptionName(option) {
      return typeof option === 'string' ? option : option.name;
    }

    normalizeValue(value) {
      var normalized = String(value || '')
        .replace(/<span class="additional-price">.*<\/span>/, '')
        .trim();
      var aliases = {...this.valueAliases, ...((this.manifest && this.manifest.aliases) || {})};
      return Object.prototype.hasOwnProperty.call(aliases, normalized) ? aliases[normalized] : normalized;
    }

    hasSelectedValue(value) {
      var normalized = this.normalizeValue(value);
      return normalized && normalized !== 'Unselected';
    }

    getCurrentSelection() {
      var selection = {};
      var variant = this.builder.getCurrentVariant ? this.builder.getCurrentVariant() : null;
      var mainOptions = (this.builder.productData && this.builder.productData.options) || [];
      var variantsElement = this.builder.querySelector('product-variants');

      if(variant && variant.options) {
        mainOptions.forEach((option, index) => {
          if(!this.shouldUseMainOptionSelection(variantsElement, index)) return;
          selection[this.getOptionName(option)] = this.normalizeValue(variant.options[index]);
        });
      }

      this.builder.querySelectorAll('tied-product').forEach(tiedProduct => {
        if(tiedProduct.classList.contains('hide')) return;
        var tiedVariant = tiedProduct.getCurrentVariant ? tiedProduct.getCurrentVariant() : null;
        if(!tiedVariant || !tiedVariant.options) return;
        if(this.isUnselectedPlaceholderTiedVariant(tiedProduct, tiedVariant)) return;

        tiedProduct.tiedProductData.options.forEach((option, index) => {
          if(mainOptions.includes(option)) return;
          selection[option] = this.normalizeValue(tiedVariant.options[index]);
        });
      });

      return selection;
    }

    shouldUseMainOptionSelection(variantsElement, optionIndex) {
      if(!variantsElement || variantsElement.dataset.deferredSelection !== 'true') return true;
      var selectedOptions = variantsElement.selectedOptions || {};
      return Object.prototype.hasOwnProperty.call(selectedOptions, String(optionIndex));
    }

    isPlaceholderVariantId(value) {
      return /^9{6,}/.test(String(value || ''));
    }

    isUnselectedPlaceholderTiedVariant(tiedProduct, tiedVariant) {
      if(!tiedProduct) return false;
      if(tiedProduct.dataset.userSelected !== 'true') return true;
      var variantId = tiedVariant && tiedVariant.id ? tiedVariant.id : tiedProduct.variantInput && tiedProduct.variantInput.value;
      return this.isPlaceholderVariantId(variantId);
    }

    getActiveManifest(selection) {
      if(!this.manifest || !this.manifest.sizes) return this.manifest || {};

      var size = selection && selection.Size;
      return size && this.manifest.sizes[size] ? this.manifest.sizes[size] : {};
    }

    getActiveLayers(selection) {
      var activeManifest = this.getActiveManifest(selection);
      return activeManifest.layers || this.manifest.layers || [];
    }

    getActiveRequiredGroups(selection) {
      var activeManifest = this.getActiveManifest(selection);
      var requiredGroups;
      if(Array.isArray(activeManifest.requiredGroups)) {
        requiredGroups = activeManifest.requiredGroups;
      } else if(Array.isArray(this.manifest.requiredGroups)) {
        requiredGroups = this.manifest.requiredGroups;
      } else {
        requiredGroups = [...new Set(this.getActiveLayers(selection).filter(layer => layer.required).map(layer => layer.group))];
      }

      if(this.isTransparentMaterial(selection.Material)) {
        return requiredGroups.filter(group => group !== 'backing' && group !== 'glass');
      }

      return requiredGroups.filter(group => group !== 'glass');
    }

    isTransparentMaterial(value) {
      var transparentMaterials = this.manifest.transparentMaterials || [];
      var normalized = this.normalizeValue(value);
      return transparentMaterials.map(material => this.normalizeValue(material)).includes(normalized);
    }

    getActiveCanvasConfig(selection) {
      var activeManifest = this.getActiveManifest(selection);
      return activeManifest.canvas || this.manifest.canvas || {};
    }

    getResolvedCanvasSize(canvasConfig, layerEntries) {
      canvasConfig = canvasConfig || {};
      var width = Number(canvasConfig.width || 0) || 1200;
      var height = Number(canvasConfig.height || 0) || width || 1200;

      (layerEntries || []).forEach(entry => {
        var image = entry.image || entry;
        var sourceWidth = Number(image.naturalWidth || image.width || 0);
        var sourceHeight = Number(image.naturalHeight || image.height || 0);
        if(sourceWidth > width) width = sourceWidth;
        if(sourceHeight > height) height = sourceHeight;
      });

      var maxDimension = Number(this.manifest.maxCanvasDimension || 2430);
      if(maxDimension > 0 && (width > maxDimension || height > maxDimension)) {
        var scale = Math.min(maxDimension / width, maxDimension / height);
        width = Math.round(width * scale);
        height = Math.round(height * scale);
      }

      return {
        width: Math.max(1, Math.round(width)),
        height: Math.max(1, Math.round(height))
      };
    }

    resizeCanvas(canvas, context, size) {
      if(canvas.width !== size.width) canvas.width = size.width;
      if(canvas.height !== size.height) canvas.height = size.height;
      context.clearRect(0, 0, canvas.width, canvas.height);
    }

    createRenderCanvas(size) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      if(!context) return null;
      canvas.width = size.width;
      canvas.height = size.height;
      return { canvas, context };
    }

    waitForFrame() {
      return new Promise(resolve => requestAnimationFrame(resolve));
    }

    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    setRenderingState(isRendering) {
      if(!isRendering && this.renderTransitionFallback) {
        clearTimeout(this.renderTransitionFallback);
        this.renderTransitionFallback = null;
      }
      this.isRendering = isRendering;
      this.classList.toggle('is-rendering', isRendering);
      if(this.gallery) this.gallery.classList.toggle('builder-preview-rendering', isRendering);
      if(this.thumbs) this.thumbs.classList.toggle('builder-preview-rendering', isRendering);
      [
        this.primaryGalleryItem,
        this.primaryThumbItem,
        ...this.dynamicGalleryItems,
        ...this.dynamicThumbItems
      ].filter(Boolean).forEach(item => item.classList.toggle('is-rendering', isRendering));
    }

    beginRenderTransition() {
      if(this.renderTransitionFallback) clearTimeout(this.renderTransitionFallback);
      this.renderTransitionStartedAt = performance.now();
      this.setRenderingState(true);
      this.renderTransitionFallback = setTimeout(() => {
        this.setRenderingState(false);
      }, 2000);
    }

    async finishRenderTransition(token) {
      var elapsed = performance.now() - this.renderTransitionStartedAt;
      var minimumVisibleTransition = 160;
      if(elapsed < minimumVisibleTransition) {
        await this.wait(minimumVisibleTransition - elapsed);
      }
      await this.waitForFrame();
      await this.waitForFrame();
      await this.waitForFrame();
      if(token !== this.renderToken) return;
      this.setRenderingState(false);
    }

    getFrameTransitionSignature(selection, layers) {
      var canvasConfig = this.getActiveCanvasConfig(selection);
      var frameLayer = (layers || []).find(layer => layer.group === 'frame');
      var orientation = ['Vertical', 'Paper Goods'].includes(this.normalizeValue(selection && selection.Style)) ? 'vertical' : 'default';
      return [
        this.normalizeValue(selection && selection.Shape),
        this.normalizeValue(selection && selection.Size),
        orientation,
        canvasConfig.width || '',
        canvasConfig.height || '',
        frameLayer ? frameLayer.src : ''
      ].join('|');
    }

    shouldUseFrameTransition(frameSignature) {
      return Boolean(this.lastFrameTransitionSignature && frameSignature && frameSignature !== this.lastFrameTransitionSignature);
    }

    replaceVisibleCanvas(sourceCanvas, targetCanvas, targetContext) {
      var sameSize = targetCanvas.width === sourceCanvas.width && targetCanvas.height === sourceCanvas.height;
      if(targetCanvas.width !== sourceCanvas.width) targetCanvas.width = sourceCanvas.width;
      if(targetCanvas.height !== sourceCanvas.height) targetCanvas.height = sourceCanvas.height;
      if(sameSize) targetContext.globalCompositeOperation = 'copy';
      targetContext.drawImage(sourceCanvas, 0, 0, targetCanvas.width, targetCanvas.height);
      if(sameSize) targetContext.globalCompositeOperation = 'source-over';
      this.updatePreviewZoom(targetCanvas);
    }

    updatePreviewZoom(targetCanvas) {
      // Test formatting: the bitmap bakes in padding that varies by frame size, so a
      // fixed display zoom either wastes space (small frames) or crops (22x28). Measure
      // the drawn content on a small sample and scale the display to fill the slide.
      var builderRoot = this.closest('product-main-builder');
      if (!builderRoot || builderRoot.dataset.testFormatting != 'true') return;
      try {
        var s = 64;
        if (!this._zoomSampler) {
          this._zoomSampler = document.createElement('canvas');
          this._zoomSampler.width = s;
          this._zoomSampler.height = s;
        }
        var ctx = this._zoomSampler.getContext('2d', {willReadFrequently: true});
        ctx.clearRect(0, 0, s, s);
        ctx.drawImage(targetCanvas, 0, 0, s, s);
        var d = ctx.getImageData(0, 0, s, s).data;
        var minX = s, maxX = -1, minY = s, maxY = -1;
        for (var y = 0; y < s; y++) {
          for (var x = 0; x < s; x++) {
            var i = (y * s + x) * 4;
            if (d[i + 3] > 20 && (d[i] < 245 || d[i + 1] < 245 || d[i + 2] < 245)) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX < 0) return;
        var fill = Math.max((maxX - minX + 1) / s, (maxY - minY + 1) / s);

        // Sizes stay distinguishable: each frame targets a slide fill that grows
        // with its real long side (sqrt eases the spread so 8x10 stays readable)
        // instead of every size normalizing to the same 94%.
        var targetFill = 0.94;
        var longSide = this.getSelectedFrameLongSide(builderRoot);
        var maxLongSide = this.getMaxFrameLongSide(builderRoot);
        if (longSide && maxLongSide) {
          targetFill = 0.94 * Math.sqrt(longSide / maxLongSide);
        }

        // Sharpness cap: never display the bitmap above its native resolution —
        // upscaling past it is what made the small frames look fuzzy.
        var dpr = window.devicePixelRatio || 1;
        var sharpCap = Math.max(1, targetCanvas.height / Math.max(1, targetCanvas.clientHeight * dpr));

        var scale = Math.min(targetFill / fill, 0.94 / fill, sharpCap);
        scale = Math.max(scale, 0.5);
        targetCanvas.style.transform = 'scale(' + scale.toFixed(3) + ')';
      } catch (e) {
        /* best effort — leave the canvas unscaled if sampling fails */
      }
    }

    parseFrameLongSide(text) {
      var match = String(text || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      if (!match) return 0;
      return Math.max(parseFloat(match[1]), parseFloat(match[2]));
    }

    getSelectedFrameLongSide(builderRoot) {
      var variant = builderRoot.getCurrentVariant && builderRoot.getCurrentVariant();
      if (!variant) return 0;
      var options = variant.options || [variant.option1, variant.option2, variant.option3];
      for (var i = 0; i < options.length; i++) {
        var side = this.parseFrameLongSide(options[i]);
        if (side) return side;
      }
      return 0;
    }

    getMaxFrameLongSide(builderRoot) {
      if (this._maxFrameLongSide) return this._maxFrameLongSide;
      var max = 0;
      var variants = (builderRoot.productData && builderRoot.productData.variants) || [];
      variants.forEach((variant) => {
        (variant.options || []).forEach((option) => {
          max = Math.max(max, this.parseFrameLongSide(option));
        });
      });
      this._maxFrameLongSide = max;
      return max;
    }

    getActiveGalleryProfiles(selection) {
      var activeManifest = this.getActiveManifest(selection);
      return activeManifest.galleryProfiles || this.manifest.galleryProfiles || [];
    }

    getActiveStaticMedia(selection) {
      var activeManifest = this.getActiveManifest(selection);
      return activeManifest.staticMedia || this.manifest.staticMedia || [];
    }

    getLayerFallbacks(selection) {
      var activeManifest = this.getActiveManifest(selection);
      return [
        ...(this.manifest.layerFallbacks || []),
        ...(activeManifest.layerFallbacks || [])
      ].filter(rule => this.matchSelection(selection, rule.when || rule.match || {}));
    }

    getDefaultBaseSelection(selection) {
      var activeManifest = this.getActiveManifest(selection);
      var defaults = activeManifest.defaults || this.manifest.defaults || {};
      var configuredDefaults = {};
      if(defaults.values) {
        configuredDefaults = {...defaults.values};
      } else if(defaults.base) {
        configuredDefaults = {...defaults.base};
      } else {
        configuredDefaults = Object.keys(defaults)
        .filter(key => !['contexts', 'contextual'].includes(key))
        .reduce((selection, key) => {
          selection[key] = defaults[key];
          return selection;
        }, {});
      }

      return {...configuredDefaults, ...this.defaultPreviewSelection};
    }

    getDefaultContexts(selection) {
      var activeManifest = this.getActiveManifest(selection);
      var defaults = activeManifest.defaults || this.manifest.defaults || {};
      return defaults.contexts || defaults.contextual || [];
    }

    matchSelection(selection, match) {
      match = match || {};
      return Object.keys(match).every(key => {
        var expected = Array.isArray(match[key]) ? match[key].map(value => this.normalizeValue(value)) : this.normalizeValue(match[key]);
        if(expected === '*') return true;
        if(!this.hasSelectedValue(selection[key])) return false;
        return this.matchValue(selection[key], expected);
      });
    }

    resolvePreviewSelection(rawSelection) {
      var actualSelection = {};
      Object.keys(rawSelection || {}).forEach(key => {
        if(this.hasSelectedValue(rawSelection[key])) {
          actualSelection[key] = this.normalizeValue(rawSelection[key]);
        }
      });

      var resolvedSelection = this.getDefaultBaseSelection(actualSelection);
      this.getDefaultContexts(actualSelection).forEach(context => {
        if(this.matchSelection(actualSelection, context.when || context.match || {})) {
          resolvedSelection = {...resolvedSelection, ...(context.values || context.defaults || {})};
        }
      });
      resolvedSelection = this.applyUnselectedDefaultOverrides(resolvedSelection, actualSelection);
      resolvedSelection = {...resolvedSelection, ...actualSelection};

      var defaultedKeys = Object.keys(resolvedSelection).filter(key => key.indexOf('__') !== 0 && actualSelection[key] !== resolvedSelection[key]);
      resolvedSelection.__typeWasSelected = this.hasSelectedValue(actualSelection.Type);
      return { selection: resolvedSelection, actualSelection, defaultedKeys };
    }

    applyUnselectedDefaultOverrides(resolvedSelection, actualSelection) {
      var selection = {...resolvedSelection};
      if(!this.hasSelectedValue(actualSelection.Material)) {
        selection.Material = this.defaultPreviewSelection.Material;
      }
      return selection;
    }

    appliesToSelection(selection) {
      var appliesWhen = this.manifest.appliesWhen || {};
      return Object.keys(appliesWhen).every(key => {
        var acceptedValues = Array.isArray(appliesWhen[key]) ? appliesWhen[key] : [appliesWhen[key]];
        return acceptedValues.includes(selection[key]);
      });
    }

    matchValue(actual, expected) {
      if(expected === '*') return true;
      if(Array.isArray(expected)) return expected.includes(actual) || expected.includes('*');
      return actual === expected;
    }

    layerMatchesSelection(layer, selection) {
      var match = layer.match || {};
      return Object.keys(match).every(key => {
        var expected = Array.isArray(match[key]) ? match[key].map(value => this.normalizeValue(value)) : this.normalizeValue(match[key]);
        if(expected === '*') return true;
        if(!selection[key]) return false;
        return this.matchValue(selection[key], expected);
      });
    }

    getLayerMatchScore(layer, selection, penalty) {
      var match = layer.match || {};
      var priorityWeights = {
        Shape: 1000,
        Size: 900,
        Style: 700,
        Material: 600,
        Color: 500,
        Type: 100
      };

      return Object.keys(match).reduce((score, key) => {
        var actual = this.normalizeValue(selection[key]);
        var expected = match[key];
        var weight = priorityWeights[key] || 50;

        if(expected === '*') return score + 1;

        if(Array.isArray(expected)) {
          var expectedValues = expected.map(value => this.normalizeValue(value));
          if(expectedValues.includes(actual)) {
            return score + weight + (expectedValues.length === 1 ? 100 : 0);
          }
          if(expectedValues.includes('*')) return score + 1;
          return score;
        }

        return this.normalizeValue(expected) === actual ? score + weight + 200 : score;
      }, penalty || 0);
    }

    getLayerCandidate(layer, selection) {
      var bestCandidate = null;

      if(this.layerMatchesSelection(layer, selection)) {
        bestCandidate = {
          layer,
          score: this.getLayerMatchScore(layer, selection),
          fallback: null
        };
      }

      this.getLayerFallbacks(selection).forEach(rule => {
        if(rule.group && rule.group !== layer.group) return;
        var fallbackSelection = {...selection, ...(rule.use || rule.values || {})};
        if(!this.layerMatchesSelection(layer, fallbackSelection)) return;

        var fallbackCandidate = {
          layer,
          score: this.getLayerMatchScore(layer, fallbackSelection, -250),
          fallback: rule
        };

        if(!bestCandidate || fallbackCandidate.score > bestCandidate.score) {
          bestCandidate = fallbackCandidate;
        }
      });

      return bestCandidate;
    }

    warnLayerSelectionIssues(layers, selection) {
      layers.forEach(layer => {
        var expectedShape = layer.match && layer.match.Shape;
        if(!expectedShape || !selection.Shape) return;

        var expectedShapes = Array.isArray(expectedShape)
          ? expectedShape.map(shape => this.normalizeValue(shape))
          : [this.normalizeValue(expectedShape)];

        if(expectedShapes.includes('*')) return;

        if(!expectedShapes.includes(this.normalizeValue(selection.Shape))) {
          console.warn('Builder preview selected a layer with a mismatched shape.', {
            selectedShape: selection.Shape,
            layer
          });
        }
      });
    }

    getSelectedLayers(selection) {
      var groupedLayers = new Map();
      this.getActiveLayers(selection).forEach(layer => {
        if(!layer.group || !layer.src) return;
        if(layer.group === 'glass') return;
        var candidate = this.getLayerCandidate(layer, selection);
        if(!candidate) return;

        var current = groupedLayers.get(layer.group);
        if(!current || candidate.score > current.score) {
          groupedLayers.set(layer.group, candidate);
        }
      });

      var requiredGroups = this.getActiveRequiredGroups(selection);
      var missing = requiredGroups.filter(group => !groupedLayers.has(group));
      var layers = Array.from(groupedLayers.values()).map(candidate => candidate.layer).sort((a, b) => (a.z || 0) - (b.z || 0));
      this.warnLayerSelectionIssues(layers, selection);

      return { layers, missing };
    }

    getActiveManifestSize(selection) {
      var activeManifest = this.getActiveManifest(selection);
      return activeManifest.defaults && activeManifest.defaults.values
        ? activeManifest.defaults.values.Size
        : selection.Size;
    }

    isFilledSelectionValue(value) {
      return this.hasSelectedValue(value);
    }

    isSelectionReadyForRequiredLayers(selection) {
      var requiredGroups = this.getActiveRequiredGroups(selection);

      return requiredGroups.every(group => {
        var groupLayers = this.getActiveLayers(selection).filter(layer => layer.group === group);
        return groupLayers.some(layer => {
          var match = layer.match || {};
          return Object.keys(match).every(key => {
            var expected = match[key];
            if(expected === '*' || (Array.isArray(expected) && expected.includes('*'))) return true;
            return this.isFilledSelectionValue(selection[key]);
          });
        });
      });
    }

    setActive(isActive) {
      this.active = isActive;
      this.classList.toggle('active', isActive);
      if(this.gallery) this.gallery.classList.toggle('builder-preview-gallery-active', isActive);
      if(this.thumbs) this.thumbs.classList.toggle('builder-preview-thumbs-active', isActive);
      this.setPreviewGalleryItemsVisible(isActive);
    }

    markInitialPreviewReady() {
      if(this.builder && this.builder.dataset.productHandle === 'pressed-frame-1') {
        this.builder.classList.add('pressed-frame-preview-ready');
      }
    }

    setMessage(message) {
      var messageElement = this.querySelector('.builder-preview-compositor__message');
      if(messageElement) messageElement.textContent = message || '';
    }

    getPreviewMediaId(id) {
      return 'builder-preview-' + (id || 'selected');
    }

    movePreviewItemsToFront(options = {}) {
      var moveGallery = options.gallery !== false;
      var moveThumbs = options.thumbs !== false;

      if(moveGallery && this.galleryWrapper) {
        [...this.dynamicGalleryItems].reverse().forEach(item => {
          if(item.parentNode === this.galleryWrapper) {
            this.galleryWrapper.insertBefore(item, this.galleryWrapper.firstElementChild);
          }
        });
        if(this.primaryGalleryItem && this.primaryGalleryItem.parentNode === this.galleryWrapper) {
          this.galleryWrapper.insertBefore(this.primaryGalleryItem, this.galleryWrapper.firstElementChild);
        }
      }

      if(moveThumbs && this.thumbsWrapper) {
        [...this.dynamicThumbItems].reverse().forEach(item => {
          if(item.parentNode === this.thumbsWrapper) {
            this.thumbsWrapper.insertBefore(item, this.thumbsWrapper.firstElementChild);
          }
        });
        if(this.primaryThumbItem && this.primaryThumbItem.parentNode === this.thumbsWrapper) {
          this.thumbsWrapper.insertBefore(this.primaryThumbItem, this.thumbsWrapper.firstElementChild);
        }
      }
    }

    refreshNativeGallery(options = {}) {
      var refreshGallery = options.refreshGallery !== false;
      var refreshThumbs = options.refreshThumbs !== false;

      this.movePreviewItemsToFront({ gallery: refreshGallery, thumbs: refreshThumbs });

      if(refreshGallery && this.gallery) {
        this.gallery.dispatchEvent(new CustomEvent('deferredMediaLoaded', { detail: { element: this }}));
        if(this.gallery.slider) {
          this.gallery.itemsWrapper.querySelectorAll('.media-wrap').forEach(slide => slide.classList.add('keen-slider-slide'));
          this.gallery.slider.refresh();
          this.gallery.showItem(this.getPreviewMediaId('selected'), false);
        }
      }

      if(refreshThumbs && this.thumbs) {
        this.thumbs.dispatchEvent(new CustomEvent('deferredMediaLoaded', { detail: { element: this }}));
        if(this.thumbs.slider) {
          this.thumbs.itemsWrapper.querySelectorAll('.thumb-wrap').forEach(slide => slide.classList.add('keen-slider-slide'));
          this.thumbs.slider.refresh();
          this.thumbs.showItem(this.getPreviewMediaId('selected'), false);
        }
      }
    }

    setPreviewGalleryItemsVisible(isVisible) {
      [
        this.primaryGalleryItem,
        this.primaryThumbItem,
        ...this.dynamicGalleryItems,
        ...this.dynamicThumbItems
      ].filter(Boolean).forEach(item => {
        item.style.display = isVisible ? 'block' : 'none';
      });

      if(isVisible) {
        this.refreshNativeGallery();
      } else if(this.gallery && this.gallery.slider) {
        this.gallery.slider.refresh();
      }
    }

    getCanvasZoomSource(canvas) {
      if(!canvas || !canvas.width || !canvas.height) return null;
      // Flatten onto white: the composite has transparent padding, which would render
      // as black in a JPEG (and float oddly on the lightbox background as a PNG).
      var out = document.createElement('canvas');
      out.width = canvas.width;
      out.height = canvas.height;
      var ctx = out.getContext('2d');
      if(!ctx) return null;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, out.width, out.height);
      ctx.drawImage(canvas, 0, 0);
      return out.toDataURL('image/jpeg', 0.92);
    }

    bindPreviewZoom(item, getSource) {
      // Compositor items aren't [data-file] media, so ProductGallery's PhotoSwipe
      // binding never sees them; open the lightbox with a snapshot instead. toDataURL
      // is legal because loadImage sets crossOrigin='anonymous' on every layer.
      item.addEventListener('click', ()=>{
        if(!window.$s || !$s.photoSwipe) return;
        var src;
        try {
          src = getSource();
        } catch(error) {
          console.warn('Frame preview zoom unavailable', error);
          return;
        }
        if(!src) return;
        var stub = document.createElement('img');
        stub.dataset.file = src;
        var label = item.getAttribute('aria-label');
        if(label) stub.dataset.title = label;
        $s.photoSwipe([stub], stub);
      });
    }

    createGalleryCanvasItem(id, label, canvas) {
      var item = document.createElement('div');
      item.className = 'image-wrap media-wrap builder-preview-gallery-item builder-preview-gallery-item--dynamic';
      item.dataset.mediaId = this.getPreviewMediaId(id);
      item.dataset.builderPreviewDynamic = 'true';
      item.dataset.alwaysVisible = 'true';
      item.dataset.originalMediaIndex = id === 'selected' ? '-200' : '-100';
      item.setAttribute('aria-label', label || 'Configured frame preview');
      item.style.display = this.active ? 'block' : 'none';
      if(this.isRendering) item.classList.add('is-rendering');

      canvas = canvas || document.createElement('canvas');
      canvas.classList.add('builder-preview-compositor__canvas');
      item.appendChild(canvas);
      this.bindPreviewZoom(item, ()=>this.getCanvasZoomSource(canvas));

      if(this.galleryWrapper) {
        this.galleryWrapper.insertBefore(item, this.galleryWrapper.firstElementChild);
      }

      return { item, canvas };
    }

    createGalleryStaticItem(media) {
      var item = document.createElement('div');
      item.className = 'image-wrap media-wrap builder-preview-gallery-item builder-preview-gallery-item--static';
      item.dataset.mediaId = this.getPreviewMediaId(media.id || 'static-' + this.dynamicGalleryItems.length);
      item.dataset.builderPreviewDynamic = 'true';
      item.dataset.alwaysVisible = 'true';
      item.dataset.originalMediaIndex = '-90';
      item.setAttribute('aria-label', media.label || media.alt || 'Frame detail');
      item.style.display = this.active ? 'block' : 'none';
      if(this.isRendering) item.classList.add('is-rendering');

      var image = document.createElement('img');
      image.loading = 'lazy';
      image.decoding = 'async';
      image.alt = media.alt || media.label || '';
      image.src = media.src;
      item.appendChild(image);
      this.bindPreviewZoom(item, ()=>image.src);

      if(this.galleryWrapper) {
        this.galleryWrapper.insertBefore(item, this.galleryWrapper.firstElementChild);
      }

      this.dynamicGalleryItems.push(item);
      return item;
    }

    createThumbCanvasItem(id, label) {
      if(!this.thumbsWrapper) return { item: null, canvas: null };

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'thumb-wrap builder-preview-thumb-item';
      item.dataset.mediaId = this.getPreviewMediaId(id);
      item.dataset.builderPreviewDynamic = 'true';
      item.dataset.alwaysVisible = 'true';
      item.dataset.originalMediaIndex = id === 'selected' ? '-200' : '-100';
      item.setAttribute('aria-label', label || 'Configured frame preview');
      item.style.display = this.active ? 'block' : 'none';
      if(this.isRendering) item.classList.add('is-rendering');

      var canvas = document.createElement('canvas');
      canvas.className = 'builder-preview-compositor__thumb-canvas';
      item.appendChild(canvas);
      this.thumbsWrapper.insertBefore(item, this.thumbsWrapper.firstElementChild);

      return { item, canvas };
    }

    createThumbStaticItem(media) {
      if(!this.thumbsWrapper) return null;

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'thumb-wrap builder-preview-thumb-item';
      item.dataset.mediaId = this.getPreviewMediaId(media.id || 'static-' + this.dynamicThumbItems.length);
      item.dataset.builderPreviewDynamic = 'true';
      item.dataset.alwaysVisible = 'true';
      item.dataset.originalMediaIndex = '-90';
      item.setAttribute('aria-label', media.label || media.alt || 'Frame detail');
      item.style.display = this.active ? 'block' : 'none';
      if(this.isRendering) item.classList.add('is-rendering');

      var image = document.createElement('img');
      image.loading = 'lazy';
      image.decoding = 'async';
      image.alt = media.alt || media.label || '';
      image.src = media.src;
      item.appendChild(image);
      this.thumbsWrapper.insertBefore(item, this.thumbsWrapper.firstElementChild);

      this.dynamicThumbItems.push(item);
      return item;
    }

    ensurePrimaryGalleryItem() {
      this.refreshGalleryRefs();
      if(this.primaryGalleryItem || !this.galleryWrapper) return;

      var galleryItem = this.createGalleryCanvasItem('selected', 'Selected frame', this.canvas);
      this.primaryGalleryItem = galleryItem.item;

      var thumbItem = this.createThumbCanvasItem('selected', 'Selected frame');
      this.primaryThumbItem = thumbItem.item;
      this.primaryThumbCanvas = thumbItem.canvas;
      this.refreshNativeGallery();
    }

    clearDynamicGalleryItems(options = {}) {
      var clearGallery = options.gallery !== false;
      var clearThumbs = options.thumbs !== false;

      if(clearGallery) {
        this.dynamicGalleryItems.forEach(item => item.remove());
        this.dynamicGalleryItems = [];
        this.hasRenderedAdjacentGallery = false;
      }

      if(clearThumbs) {
        this.dynamicThumbItems.forEach(item => item.remove());
        this.dynamicThumbItems = [];
      }
    }

    copyCanvasToThumb(sourceCanvas, targetCanvas) {
      if(!targetCanvas) return;
      var thumbContext = targetCanvas.getContext('2d');
      if(!thumbContext) return;

      var thumbSize = Number(this.manifest.thumbnailCanvasSize || 240);
      targetCanvas.width = thumbSize;
      targetCanvas.height = thumbSize;
      thumbContext.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
      thumbContext.drawImage(sourceCanvas, 0, 0, targetCanvas.width, targetCanvas.height);
    }

    getResizedShopifyImageSrc(src, width) {
      if(!src || !width) return src;

      try {
        var url = new URL(src, window.location.origin);
        url.searchParams.set('width', String(width));
        return url.toString();
      } catch(error) {
        var separator = src.includes('?') ? '&' : '?';
        return src + separator + 'width=' + encodeURIComponent(width);
      }
    }

    getLayerThumbSrc(layer) {
      if(!layer) return '';
      return this.getResizedShopifyImageSrc(layer.src, 240);
    }

    loadImage(src) {
      if(this.imageCache.has(src)) return this.imageCache.get(src);

      var promise = new Promise((resolve, reject) => {
        var image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('Unable to load preview layer'));
        image.src = src;
      });

      this.imageCache.set(src, promise);
      return promise;
    }

    getImageAlphaBounds(image) {
      if(this.imageBoundsCache.has(image)) return this.imageBoundsCache.get(image);

      var scratchCanvas = document.createElement('canvas');
      scratchCanvas.width = image.naturalWidth || image.width;
      scratchCanvas.height = image.naturalHeight || image.height;
      var scratchContext = scratchCanvas.getContext('2d', { willReadFrequently: true });
      scratchContext.drawImage(image, 0, 0);

      var pixels = scratchContext.getImageData(0, 0, scratchCanvas.width, scratchCanvas.height).data;
      var minX = scratchCanvas.width;
      var minY = scratchCanvas.height;
      var maxX = -1;
      var maxY = -1;

      for(var y = 0; y < scratchCanvas.height; y++) {
        for(var x = 0; x < scratchCanvas.width; x++) {
          var alpha = pixels[((y * scratchCanvas.width + x) * 4) + 3];
          if(alpha > 0) {
            if(x < minX) minX = x;
            if(y < minY) minY = y;
            if(x > maxX) maxX = x;
            if(y > maxY) maxY = y;
          }
        }
      }

      var bounds = maxX >= 0
        ? { x: minX, y: minY, width: maxX - minX + 1, height: maxY - minY + 1 }
        : null;

      this.imageBoundsCache.set(image, bounds);
      return bounds;
    }

    getFrameOpeningBounds(image) {
      if(this.frameOpeningBoundsCache.has(image)) return this.frameOpeningBoundsCache.get(image);

      var scratchCanvas = document.createElement('canvas');
      scratchCanvas.width = image.naturalWidth || image.width;
      scratchCanvas.height = image.naturalHeight || image.height;
      var scratchContext = scratchCanvas.getContext('2d', { willReadFrequently: true });
      scratchContext.drawImage(image, 0, 0);

      var pixels = scratchContext.getImageData(0, 0, scratchCanvas.width, scratchCanvas.height).data;
      var width = scratchCanvas.width;
      var height = scratchCanvas.height;
      var startX = Math.floor(width / 2);
      var startY = Math.floor(height / 2);
      var startIndex = ((startY * width + startX) * 4) + 3;
      var alphaThreshold = 16;

      if(pixels[startIndex] > alphaThreshold) {
        this.frameOpeningBoundsCache.set(image, null);
        return null;
      }

      var seen = new Uint8Array(width * height);
      var queue = new Int32Array(width * height);
      var head = 0;
      var tail = 0;
      var startPixelIndex = (startY * width) + startX;
      queue[tail] = startPixelIndex;
      tail += 1;
      seen[startPixelIndex] = 1;
      var minX = startX;
      var minY = startY;
      var maxX = startX;
      var maxY = startY;

      while(head < tail) {
        var pixelIndex = queue[head];
        head += 1;
        var x = pixelIndex % width;
        var y = Math.floor(pixelIndex / width);
        if(x < minX) minX = x;
        if(y < minY) minY = y;
        if(x > maxX) maxX = x;
        if(y > maxY) maxY = y;

        if(x + 1 < width) {
          var rightIndex = pixelIndex + 1;
          if(!seen[rightIndex] && pixels[(rightIndex * 4) + 3] <= alphaThreshold) {
            seen[rightIndex] = 1;
            queue[tail] = rightIndex;
            tail += 1;
          }
        }
        if(x - 1 >= 0) {
          var leftIndex = pixelIndex - 1;
          if(!seen[leftIndex] && pixels[(leftIndex * 4) + 3] <= alphaThreshold) {
            seen[leftIndex] = 1;
            queue[tail] = leftIndex;
            tail += 1;
          }
        }
        if(y + 1 < height) {
          var bottomIndex = pixelIndex + width;
          if(!seen[bottomIndex] && pixels[(bottomIndex * 4) + 3] <= alphaThreshold) {
            seen[bottomIndex] = 1;
            queue[tail] = bottomIndex;
            tail += 1;
          }
        }
        if(y - 1 >= 0) {
          var topIndex = pixelIndex - width;
          if(!seen[topIndex] && pixels[(topIndex * 4) + 3] <= alphaThreshold) {
            seen[topIndex] = 1;
            queue[tail] = topIndex;
            tail += 1;
          }
        }
      }

      var bounds = {
        x: minX,
        y: minY,
        width: maxX - minX + 1,
        height: maxY - minY + 1
      };

      this.frameOpeningBoundsCache.set(image, bounds);
      return bounds;
    }

    getPaddedSourceBounds(bounds, sourceWidth, sourceHeight) {
      if(!bounds || !sourceWidth || !sourceHeight) return null;

      var padX = bounds.width * 0.08;
      var padY = bounds.height * 0.08;
      var minX = Math.max(0, bounds.x - padX);
      var minY = Math.max(0, bounds.y - padY);
      var maxX = Math.min(sourceWidth, bounds.x + bounds.width + padX);
      var maxY = Math.min(sourceHeight, bounds.y + bounds.height + padY);

      return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
    }

    getLayerSourceBounds(layerEntries) {
      var bounds = layerEntries
        .map(entry => this.getImageAlphaBounds(entry.image || entry))
        .filter(Boolean);

      if(bounds.length === 0) return null;

      var minX = Math.min(...bounds.map(bound => bound.x));
      var minY = Math.min(...bounds.map(bound => bound.y));
      var maxX = Math.max(...bounds.map(bound => bound.x + bound.width));
      var maxY = Math.max(...bounds.map(bound => bound.y + bound.height));
      var firstImage = layerEntries[0].image || layerEntries[0];
      var sourceWidth = firstImage.naturalWidth || firstImage.width;
      var sourceHeight = firstImage.naturalHeight || firstImage.height;

      return this.getPaddedSourceBounds(
        { x: minX, y: minY, width: maxX - minX, height: maxY - minY },
        sourceWidth,
        sourceHeight
      );
    }

    getFrameAnchoredSourceBounds(layerEntries, canvas, selection) {
      var frameEntry = layerEntries.find(entry => entry.layer && entry.layer.group === 'frame');
      if(!frameEntry) return null;

      var frameAlignmentBounds = this.getFrameAlignmentBounds(selection || {});
      var alignedFrameCanvas = this.getAlignedFrameCanvas(frameEntry, canvas, frameAlignmentBounds);
      if(!alignedFrameCanvas) return null;

      var frameBounds = this.getImageAlphaBounds(alignedFrameCanvas);
      return this.getPaddedSourceBounds(
        frameBounds,
        alignedFrameCanvas.width,
        alignedFrameCanvas.height
      );
    }

    getLayerBleedPixels(layer) {
      if(!layer) return 0;
      if(typeof layer.bleedPixels === 'number') return layer.bleedPixels;

      var match = layer.match || {};
      if(layer.group === 'backing' && match.Size === '18x24' && match.Shape === 'Rectangle') {
        return 18;
      }

      return 0;
    }

    getFrameAlignmentBounds(selection) {
      var shape = this.normalizeValue(selection && selection.Shape);
      var size = this.normalizeValue(selection && selection.Size);
      var orientation = ['Vertical', 'Paper Goods'].includes(this.normalizeValue(selection && selection.Style)) ? 'vertical' : 'default';
      var alignmentBounds = {
        Rectangle: {
          '8x10': {
            default: {x: 810, y: 899, width: 809.5, height: 637},
            vertical: {x: 896, y: 809.5, width: 637.5, height: 810}
          },
          '11x14': {
            default: {x: 634.5, y: 765, width: 1156, height: 898},
            vertical: {x: 770, y: 641.5, width: 898.5, height: 1156}
          },
          '16x20': {
            default: {x: 567.5, y: 695, width: 1295.5, height: 1036.5},
            vertical: {x: 686, y: 556.5, width: 1056, height: 1320.5}
          },
          '18x24': {
            default: {x: 507.5, y: 674.5, width: 1436.5, height: 1077.5},
            vertical: {x: 683, y: 504, width: 1068, height: 1421}
          },
          '22x28': {
            default: {x: 417, y: 579.5, width: 1593.5, height: 1257},
            vertical: {x: 583.5, y: 409.5, width: 1257, height: 1593}
          }
        },
        Oval: {
          '8x10': {
            default: {x: 900, y: 811, width: 628, height: 803}
          },
          '11x14': {
            default: {x: 807, y: 684, width: 819, height: 1056}
          },
          '16x20': {
            default: {x: 710, y: 577, width: 1009, height: 1273}
          },
          '18x24': {
            default: {x: 659, y: 468, width: 1115, height: 1509}
          }
        }
      };

      var shapeBounds = alignmentBounds[shape];
      if(!shapeBounds || !shapeBounds[size]) return null;
      return shapeBounds[size][orientation] || shapeBounds[size].default || null;
    }

    drawAlignedFrameLayerEntry(entry, canvas, context, targetBounds) {
      var alignedFrameCanvas = this.getAlignedFrameCanvas(entry, canvas, targetBounds);
      if(!alignedFrameCanvas) return false;

      context.drawImage(alignedFrameCanvas, 0, 0);
      return true;
    }

    getAlignedFrameCanvas(entry, canvas, targetBounds) {
      var image = entry.image || entry;
      var imageBounds = this.getFrameOpeningBounds(image) || this.getImageAlphaBounds(image);
      if(!imageBounds || !targetBounds) return null;

      var sourceWidth = image.naturalWidth || image.width;
      var sourceHeight = image.naturalHeight || image.height;
      if(!sourceWidth || !sourceHeight || !imageBounds.width || !imageBounds.height) return null;

      var cacheKey = [
        entry.layer && entry.layer.src,
        canvas.width,
        canvas.height,
        targetBounds.x,
        targetBounds.y,
        targetBounds.width,
        targetBounds.height
      ].join('|');

      if(this.frameRenderCache.has(cacheKey)) {
        return this.frameRenderCache.get(cacheKey);
      }

      var scaleX = targetBounds.width / imageBounds.width;
      var scaleY = targetBounds.height / imageBounds.height;
      var drawX = targetBounds.x - (imageBounds.x * scaleX);
      var drawY = targetBounds.y - (imageBounds.y * scaleY);
      var drawWidth = sourceWidth * scaleX;
      var drawHeight = sourceHeight * scaleY;

      var frameCanvas = document.createElement('canvas');
      var frameContext = frameCanvas.getContext('2d');
      if(!frameContext) return null;
      frameCanvas.width = canvas.width;
      frameCanvas.height = canvas.height;
      frameContext.drawImage(image, 0, 0, sourceWidth, sourceHeight, drawX, drawY, drawWidth, drawHeight);

      this.frameRenderCache.set(cacheKey, frameCanvas);
      if(this.frameRenderCache.size > this.frameRenderCacheLimit) {
        var oldestCacheKey = this.frameRenderCache.keys().next().value;
        this.frameRenderCache.delete(oldestCacheKey);
      }
      return frameCanvas;
    }

    drawLayerEntry(entry, canvas, context, sourceBounds, drawX, drawY, drawWidth, drawHeight, selection) {
      var image = entry.image || entry;
      var bleedPixels = this.getLayerBleedPixels(entry.layer);
      var isFrameLayer = entry.layer && entry.layer.group === 'frame';
      var frameAlignmentBounds = isFrameLayer ? this.getFrameAlignmentBounds(selection || {}) : null;

      if(!sourceBounds) {
        if(isFrameLayer) {
          if(this.drawAlignedFrameLayerEntry(entry, canvas, context, frameAlignmentBounds)) {
            return;
          }
        }

        context.drawImage(
          image,
          -bleedPixels,
          -bleedPixels,
          canvas.width + (bleedPixels * 2),
          canvas.height + (bleedPixels * 2)
        );
        return;
      }

      if(isFrameLayer && frameAlignmentBounds) {
        var alignedFrameCanvas = this.getAlignedFrameCanvas(entry, canvas, frameAlignmentBounds);
        if(alignedFrameCanvas) {
          image = alignedFrameCanvas;
          bleedPixels = 0;
        }
      }

      var sourceBleedX = Math.min(bleedPixels, sourceBounds.x);
      var sourceBleedY = Math.min(bleedPixels, sourceBounds.y);
      var sourceRightBleed = Math.min(bleedPixels, (image.naturalWidth || image.width) - sourceBounds.x - sourceBounds.width);
      var sourceBottomBleed = Math.min(bleedPixels, (image.naturalHeight || image.height) - sourceBounds.y - sourceBounds.height);
      var scaleX = drawWidth / sourceBounds.width;
      var scaleY = drawHeight / sourceBounds.height;

      context.drawImage(
        image,
        sourceBounds.x - sourceBleedX,
        sourceBounds.y - sourceBleedY,
        sourceBounds.width + sourceBleedX + sourceRightBleed,
        sourceBounds.height + sourceBleedY + sourceBottomBleed,
        drawX - (sourceBleedX * scaleX),
        drawY - (sourceBleedY * scaleY),
        drawWidth + ((sourceBleedX + sourceRightBleed) * scaleX),
        drawHeight + ((sourceBleedY + sourceBottomBleed) * scaleY)
      );
    }

    drawComposedLayers(layerEntries, canvas = this.canvas, context = this.context, selection = {}) {
      var sourceBounds = null;

      try {
        if(this.manifest.fitToContent) {
          sourceBounds = this.getFrameAnchoredSourceBounds(layerEntries, canvas, selection) || this.getLayerSourceBounds(layerEntries);
        }
      } catch(error) {
        console.warn('Builder preview could not calculate layer bounds', error);
      }

      if(!sourceBounds) {
        layerEntries.forEach(entry => {
          this.drawLayerEntry(entry, canvas, context, null, null, null, null, null, selection);
        });
        return;
      }

      var fitScale = typeof this.manifest.fitScale === 'number' ? this.manifest.fitScale : 1;
      var scale = Math.min(canvas.width / sourceBounds.width, canvas.height / sourceBounds.height) * fitScale;
      var drawWidth = sourceBounds.width * scale;
      var drawHeight = sourceBounds.height * scale;
      var drawX = (canvas.width - drawWidth) / 2;
      var drawY = (canvas.height - drawHeight) / 2;

      layerEntries.forEach(entry => {
        this.drawLayerEntry(entry, canvas, context, sourceBounds, drawX, drawY, drawWidth, drawHeight, selection);
      });
    }

    async composeSelectionToCanvas(selection, canvas, context) {
      var layerResult = this.getSelectedLayers(selection);
      var canvasConfig = this.getActiveCanvasConfig(selection);

      if(layerResult.missing.length > 0) {
        return { rendered: false, missing: layerResult.missing };
      }

      var layerEntries = await Promise.all(layerResult.layers.map(layer => {
        return this.loadImage(layer.src).then(image => ({ image, layer }));
      }));
      var size = this.getResolvedCanvasSize(canvasConfig, layerEntries);
      var renderCanvas = this.createRenderCanvas(size);
      if(!renderCanvas) return { rendered: false, missing: ['canvas'] };

      this.drawComposedLayers(layerEntries, renderCanvas.canvas, renderCanvas.context, selection);
      this.replaceVisibleCanvas(renderCanvas.canvas, canvas, context);
      return { rendered: true, missing: [] };
    }

    getGalleryProfile(selection) {
      var profiles = this.getActiveGalleryProfiles(selection);
      return profiles.find(profile => this.matchSelection(selection, profile.match || {})) || profiles[0] || null;
    }

    getSelectionWithPriorityOverride(currentSelection, overridePriority) {
      var candidateSelection = {...currentSelection};
      var overrideKeys = Object.keys(overridePriority || {});

      for(var i = 0; i < overrideKeys.length; i++) {
        var key = overrideKeys[i];
        var values = Array.isArray(overridePriority[key]) ? overridePriority[key] : [overridePriority[key]];
        var selectedValue = currentSelection[key];
        var replacement = values.find(value => {
          var normalizedValue = this.normalizeValue(value);
          if(normalizedValue === selectedValue) return false;

          var testSelection = {...candidateSelection, [key]: normalizedValue};
          return this.getSelectedLayers(testSelection).missing.length === 0;
        });

        if(!replacement) return null;
        candidateSelection[key] = this.normalizeValue(replacement);
      }

      return candidateSelection;
    }

    getGalleryViewSelections(resolvedSelection) {
      var profile = this.getGalleryProfile(resolvedSelection);
      var views = profile && Array.isArray(profile.views) ? profile.views : [];
      if(views.length === 0) {
        views = [{ id: 'selected', label: 'Selected frame', selection: 'current' }];
      }

      return views.map(view => {
        if(view.selection === 'current') {
          return {...view, resolvedSelection};
        }

        var selectionConfig = view.selection || {};
        var viewSelection = {...resolvedSelection};

        if(selectionConfig.override) {
          viewSelection = {...viewSelection, ...selectionConfig.override};
        }

        if(selectionConfig.overridePriority) {
          viewSelection = this.getSelectionWithPriorityOverride(viewSelection, selectionConfig.overridePriority);
        }

        if(!viewSelection || this.getSelectedLayers(viewSelection).missing.length > 0) {
          return null;
        }

        return {...view, resolvedSelection: viewSelection};
      }).filter(Boolean);
    }

    getMatchedStaticMedia(selection) {
      return this.getActiveStaticMedia(selection).filter(media => media.src && this.matchSelection(selection, media.match || {}));
    }

    async renderAdjacentGallery(resolvedSelection, token, options = {}) {
      var rebuildGallery = options.rebuildGallery !== false || !this.hasRenderedAdjacentGallery;

      this.clearDynamicGalleryItems({ gallery: rebuildGallery, thumbs: true });
      this.ensurePrimaryGalleryItem();

      var viewSelections = this.getGalleryViewSelections(resolvedSelection).slice(1);
      var maxDynamicViews = Number(this.manifest.maxDynamicGalleryViews || 4);
      var dynamicViews = viewSelections.slice(0, Math.max(0, maxDynamicViews - 1));

      for(var i = 0; i < dynamicViews.length; i++) {
        if(token !== this.renderToken) return;
        var view = dynamicViews[i];
        var galleryItem = rebuildGallery
          ? this.createGalleryCanvasItem(view.id || ('dynamic-' + i), view.label || view.id)
          : { item: null, canvas: document.createElement('canvas') };
        if(galleryItem.item) this.dynamicGalleryItems.push(galleryItem.item);
        var thumbItem = this.createThumbCanvasItem(view.id || ('dynamic-' + i), view.label || view.id);
        if(thumbItem.item) this.dynamicThumbItems.push(thumbItem.item);
        var canvas = galleryItem.canvas;
        var context = canvas.getContext('2d');
        if(!context) continue;
        try {
          var result = await this.composeSelectionToCanvas(view.resolvedSelection, canvas, context);
          if(!result.rendered) {
            if(galleryItem.item) galleryItem.item.remove();
            if(thumbItem.item) thumbItem.item.remove();
            this.dynamicGalleryItems = this.dynamicGalleryItems.filter(item => item !== galleryItem.item);
            this.dynamicThumbItems = this.dynamicThumbItems.filter(item => item !== thumbItem.item);
            continue;
          }
          this.copyCanvasToThumb(canvas, thumbItem.canvas);
        } catch(error) {
          if(galleryItem.item) galleryItem.item.remove();
          if(thumbItem.item) thumbItem.item.remove();
          this.dynamicGalleryItems = this.dynamicGalleryItems.filter(item => item !== galleryItem.item);
          this.dynamicThumbItems = this.dynamicThumbItems.filter(item => item !== thumbItem.item);
          console.warn('Builder preview skipped an unavailable gallery view.', { view, error });
        }
      }

      this.getMatchedStaticMedia(resolvedSelection).forEach(media => {
        if(rebuildGallery) this.createGalleryStaticItem(media);
        this.createThumbStaticItem(media);
      });

      if(rebuildGallery) this.hasRenderedAdjacentGallery = true;
      this.refreshNativeGallery({ refreshGallery: rebuildGallery, refreshThumbs: true });
    }

    async render() {
      if(!this.manifest || !this.canvas || !this.context) return;

      var token = ++this.renderToken;
      var rawSelection = this.getCurrentSelection();
      var previewSelection = this.resolvePreviewSelection(rawSelection);
      var selection = previewSelection.selection;
      if(!this.appliesToSelection(selection)) {
        this.missingRequiredLayers = [];
        this.setMessage('');
        this.setActive(false);
        this.setRenderingState(false);
        this.clearDynamicGalleryItems();
        this.markInitialPreviewReady();
        return;
      }

      var layerResult = this.getSelectedLayers(selection);
      this.missingRequiredLayers = layerResult.missing;
      var frameTransitionSignature = this.getFrameTransitionSignature(selection, layerResult.layers);
      var useFrameTransition = this.shouldUseFrameTransition(frameTransitionSignature);

      if(this.missingRequiredLayers.length > 0) {
        this.clearDynamicGalleryItems();
        this.ensurePrimaryGalleryItem();
        this.setActive(true);

        var missingCanvasConfig = this.getActiveCanvasConfig(selection);
        this.resizeCanvas(this.canvas, this.context, this.getResolvedCanvasSize(missingCanvasConfig, []));
        this.copyCanvasToThumb(this.canvas, this.primaryThumbCanvas);
        this.setMessage('A layered preview is missing for: ' + this.missingRequiredLayers.join(', ') + '.');
        this.markInitialPreviewReady();
        this.setRenderingState(false);
        return;
      }

      this.setActive(true);
      try {
        this.ensurePrimaryGalleryItem();
        this.beginRenderTransition();
        var mainResult = await this.composeSelectionToCanvas(selection, this.canvas, this.context);
        if(token !== this.renderToken) return;

        if(!mainResult.rendered) {
          this.missingRequiredLayers = mainResult.missing;
          this.setMessage('A preview image is unavailable for this combination.');
          this.setRenderingState(false);
          return;
        }

        this.copyCanvasToThumb(this.canvas, this.primaryThumbCanvas);
        await this.renderAdjacentGallery(selection, token, { rebuildGallery: useFrameTransition });
        if(token !== this.renderToken) return;

        this.lastFrameTransitionSignature = frameTransitionSignature;
        this.markInitialPreviewReady();
        this.setMessage('');
        await this.finishRenderTransition(token);
      } catch(error) {
        if(token !== this.renderToken) return;
        this.clearDynamicGalleryItems();
        this.ensurePrimaryGalleryItem();
        var errorCanvasConfig = this.getActiveCanvasConfig(selection);
        this.resizeCanvas(this.canvas, this.context, this.getResolvedCanvasSize(errorCanvasConfig, []));
        this.copyCanvasToThumb(this.canvas, this.primaryThumbCanvas);
        this.missingRequiredLayers = ['image'];
        this.setMessage('A preview image is unavailable for this combination.');
        this.markInitialPreviewReady();
        this.setRenderingState(false);
        console.warn('Builder preview render failed', error);
      }
    }

    isActive() {
      return this.active;
    }

    getBlockingMessage() {
      if(!this.isActive()) return '';
      var missingCartOptions = this.getMissingRequiredCartOptions();
      if(missingCartOptions.length > 0) {
        return 'Please select all required frame details before checkout.';
      }
      if(this.missingRequiredLayers.length > 0) {
        return 'A preview image is missing for this combination. Please choose another option or add the missing layer asset before checkout.';
      }
      return '';
    }

    getMissingRequiredCartOptions() {
      var requiredForCart = this.manifest.requiredForCart || [];
      if(!Array.isArray(requiredForCart) || requiredForCart.length === 0) return [];

      var rawSelection = this.getCurrentSelection();
      var previewSelection = this.resolvePreviewSelection(rawSelection);
      return requiredForCart.filter(optionName => !this.hasSelectedValue(previewSelection.selection[optionName]));
    }

    validateForAddToCart() {
      var message = this.getBlockingMessage();
      if(message) {
        this.setMessage(message);
        return false;
      }
      return true;
    }

    getPreviewPropertyNames() {
      var names = [
        '_preview_visual_mode',
        '_preview_canvas_width',
        '_preview_canvas_height',
        '_preview_layer_count'
      ];

      for(var i = 1; i <= 4; i++) {
        names.push('_preview_layer_' + i + '_src');
        names.push('_preview_layer_' + i + '_z');
      }

      return names;
    }

    removePreviewProperties() {
      var form = this.builder.querySelector('form');
      if(!form) return;

      this.getPreviewPropertyNames().forEach(name => {
        form.querySelectorAll('input[name="properties[' + name + ']"]').forEach(input => input.remove());
      });
    }

    setPreviewProperty(name, value) {
      var form = this.builder.querySelector('form');
      if(!form || value === undefined || value === null || value === '') return;

      var inputName = 'properties[' + name + ']';
      var existingInput = form.querySelector('input[name="' + inputName + '"]');
      if(existingInput) {
        existingInput.value = value;
        return;
      }

      var hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = inputName;
      hiddenInput.value = value;
      form.appendChild(hiddenInput);
    }

    setLayeredPreviewProperties(selection, layers) {
      var canvasConfig = this.getActiveCanvasConfig(selection);
      this.removePreviewProperties();
      this.setPreviewProperty('_preview_visual_mode', 'layered');
      this.setPreviewProperty('_preview_canvas_width', canvasConfig.width || 1200);
      this.setPreviewProperty('_preview_canvas_height', canvasConfig.height || 1200);
      this.setPreviewProperty('_preview_layer_count', Math.min(layers.length, 4));

      layers.slice(0, 4).forEach((layer, index) => {
        var layerIndex = index + 1;
        this.setPreviewProperty('_preview_layer_' + layerIndex + '_src', layer.src);
        this.setPreviewProperty('_preview_layer_' + layerIndex + '_z', typeof layer.z === 'number' ? layer.z : 0);
      });
    }

    resolveLayeredCartPreview() {
      var rawSelection = this.getCurrentSelection();
      var previewSelection = this.resolvePreviewSelection(rawSelection);
      var selection = previewSelection.selection;
      var layerResult = this.getSelectedLayers(selection);
      return {
        selection,
        layers: layerResult.layers,
        missing: layerResult.missing
      };
    }

    applyCartPreviewProperties() {
      if(!this.manifest || !this.isActive()) {
        this.removePreviewProperties();
        return;
      }

      // Pure manifest matching and hidden input writes. Never gate the cart
      // submit on image loads or canvas renders here: awaiting the render
      // pipeline before submit is what caused the mobile add-to-cart hang.
      var preview = this.resolveLayeredCartPreview();
      if(preview.missing.length > 0 || preview.layers.length === 0) {
        this.removePreviewProperties();
        return;
      }

      this.setLayeredPreviewProperties(preview.selection, preview.layers);
    }

    async prepareCartPreview(options = {}) {
      this.applyCartPreviewProperties();
      return null;
    }
  }

  customElements.define('builder-preview-compositor', BuilderPreviewCompositor);
}

class PropertyOptions extends HTMLElement {
  constructor() {
    super();
    this.builder = this.closest('product-main-builder');
    this.data = JSON.parse(this.querySelector('[type="application/json"][data-property-options-json]').textContent);
    this.options = this.data.options;
    this.input = this.querySelector('[type="hidden"]');
    this.label = this.dataset.label;
    this.mainProductData = JSON.parse(this.builder.querySelector('[type="application/json"][data-product-json]').textContent);
    this.mainProductOptions = this.mainProductData.options;
    this.blockId = this.dataset.blockId;

    this.buildOptionsSelector();

    this.builder.addEventListener('mainVariantChange', (e)=>{
      this.querySelectorAll('.option-title .option-value, .option-name .option-value').forEach(span => span.innerHTML = '');
      this.buildOptions(e.detail.variant);

      if(this.data.productOptionTied){
        this.toggleComponent(e.detail.variant);
      }

    });

  }

  connectedCallback() {

    //console.log(`PropertyOptions (${this.id}) loaded`);
    this.setAttribute('data-loaded', 'true'); // Mark as loaded
    this.dispatchEvent(new CustomEvent('childElementLoaded', { bubbles: true }));

  }

  buildOptionsSelector() {

      this.setAttribute('aria-labelledby', `property-option-${$s.handleize(this.label)}-${this.builder.sectionId}`);
      this.isDropdown = this.dataset.dropdown === 'true';
      var optionElement = document.createElement('div');
      optionElement.classList.add('option');
      // Test formatting: live value in the heading; placed before .option-name so
      // bindOptions' first-match .option-value write lands here (see TiedProduct)
      var testFormatting = this.builder && this.builder.dataset.testFormatting == 'true';
      var picker = this.isDropdown
        ? `<div class="field">
            <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg>
            <select aria-labelledby="${this.getAttribute('aria-labelledby')}" data-label="${this.label}"></select>
          </div>`
        : `<div class="swatch-group flex flex-wrap"></div>`;
      optionElement.innerHTML = `
      <div class="product-swatch" data-original-label="${this.label}" id="property-option-${$s.handleize(this.label)}-${this.builder.sectionId}">
          <span class="option-title" id="${this.getAttribute('aria-labelledby')}">${this.label}${testFormatting ? ' <span aria-hidden="true" class="option-value"></span>' : ''}</span>
          <div class="flex justify-content-between">
          <div class="option-name">
              <span class="option-label">${this.label}:</span>
              <span aria-hidden="true" class="option-value"></span>
          </div>
          ${picker}
          </div>
      </div>
      `;
      this.appendChild(optionElement);
      this.buildOptions(this.builder.getCurrentVariant());

  }

  buildOptions(variant) {
    if (this.isDropdown) {
      this.buildDropdownOptions(variant);
      return;
    }
    var html = '';
    if (this.options.length > 0) {
      this.setAttribute('role', 'radiogroup');
    }

    this.options.forEach((option, index)=>{

      if(!this.validateVariantOption(variant, option.option_value_map)) return;

      var optionNameHandle = $s.handleize(this.label);
      var optionValueHandle = $s.handleize(option.value);
      var id = `swatch-${index+1}-${$s.handleize(option.value)}-${this.blockId}`;
      var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
      var imageUrl = option.image;
      var imageWidth = option.image_width;
      var imageHeight = option.image_height;
      var testFormatting = this.builder && this.builder.dataset.testFormatting == 'true';
      if(imageUrl){
          var img = document.createElement('img');
          img.classList.add('swatch-image', 'lazyload');
          img.setAttribute('data-srcset', $s.buildImgSrcset(imageUrl, testFormatting ? {width: 180, height: 180} : {width: 50, height: 50}));
          img.setAttribute('width', imageWidth);
          img.setAttribute('height', imageHeight);
          img.setAttribute('alt', option.title);
      }
      html += `
        <div class="swatch ${img ? 'image-swatch' : ''}" data-available="${option.available}">
          <input type="radio" id="${id}" name="property-${optionNameHandle}-${this.builder.sectionId}" value="${$s.escapeDomAttribute(option.value)}" />
          <label for="${id}">
            <div class="label-inner flex align-items-center justify-content-center animation ${optionNameHandle}-${optionValueHandle}">
              <span class="${img ? 'visually-hidden' : ''}">${option.value}${soldOut}</span>
              ${img ? (testFormatting ? `<span class="tile-art">${img.outerHTML}</span>` : img.outerHTML) : ''}
            </div>
          </label>
        </div>
      `;
    });
    var group = this.querySelector('.swatch-group');
    group.innerHTML = html;
    this.bindOptions();
  }

  bindOptions() {
    this.querySelectorAll('input').forEach((input)=>{
      input.addEventListener('change', (e)=>{
          var optionValueElement = this.querySelector('.option-value');
          if(optionValueElement) {
              optionValueElement.innerHTML = input.value;
              this.input.value = input.value;
              this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
          }
      });
    });
  }

  buildDropdownOptions(variant) {
    var select = this.querySelector('select');
    var previousValue = this.input.value;
    var html = `<option value="" disabled selected>${lngg.general__forms__select_option_label}</option>`;
    this.options.forEach((option)=>{
      if(!this.validateVariantOption(variant, option.option_value_map)) return;
      html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}</option>`;
    });
    select.innerHTML = html;

    // Keep the shopper's pick across variant-driven rebuilds when still valid
    if(previousValue) {
      var previousIndex = Array.from(select.options).findIndex(x=>x.value==previousValue);
      if(previousIndex >= 0) {
        select.selectedIndex = previousIndex;
        var stalePlaceholder = select.querySelector('[disabled]');
        if(stalePlaceholder) stalePlaceholder.remove();
        // mainVariantChange clears the echo spans before rebuilding — restore them
        this.querySelectorAll('.option-value').forEach(span => span.innerHTML = previousValue);
      } else {
        this.input.value = '';
        this.querySelectorAll('.option-value').forEach(span => span.innerHTML = '');
      }
    }

    if(!select.dataset.bound) {
      select.dataset.bound = 'true';
      select.addEventListener('change', ()=>{
        var value = select.value;
        this.querySelectorAll('.option-value').forEach(span => span.innerHTML = value);
        this.input.value = value;
        var placeholder = select.querySelector('[disabled]');
        if(placeholder && select.selectedOptions[0] !== placeholder) placeholder.remove();
        this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
      });
    }
  }

  validateVariantOption(variant, optionMaps) {
    var matches = 0;

    optionMaps.forEach((option)=>{
      var optionKey = Object.keys(option)[0];
      var optionValue = Object.values(option)[0];
      var optionIndex = this.mainProductOptions.findIndex(x=>x==optionKey);

      if(optionValue.includes(variant.options[optionIndex])) {
        matches++;
      }

    });
    return matches==optionMaps.length;
  }

  toggleComponent(variant){
    let found = false;
    this.data.productOptionTied.forEach(option => {
      if(variant[option.option] && variant[option.option] == option.value){
        found = true;
      }
    });

    if(found){
      this.classList.remove('hide');
      this.removeAttribute('data-not-required')
      this.classList.remove('no-step');
      this.builder.updateStepsData();
      this.builder.renderTopNav(true);
      this.builder.renderArrows();
      this.querySelectorAll('input[data-name*="items"]').forEach(input => {
        if(input.dataset.name) {
          input.setAttribute('name', input.dataset.name);
          input.removeAttribute('data-name');
        }
      })
      return;
    }
    this.classList.add('hide');
    this.querySelectorAll('input[name*="items"]').forEach(input => {
      input.setAttribute('data-name', input.name);
      input.removeAttribute('name');
    })

    this.setAttribute('data-not-required', true)
    this.classList.add('no-step');

    this.builder.updateStepsData()
    this.builder.renderTopNav(true);
    this.builder.renderArrows();
  }

}
customElements.define('property-options', PropertyOptions);

if(!customElements.get('builder-buttons')) {
  class BuilderButtons extends HTMLElement {
    constructor() {
      super();
      this.builder = this.closest('product-main-builder');
      this.mainAddButton = this.builder.querySelector('button.add');
      this.feedbackMessage = this.builder.querySelector('.feedback-msg')
      this.defaultFeedbackMessage = this.feedbackMessage ? this.feedbackMessage.innerHTML : '';
      this.button = this.querySelector('.btn');
      this.missingValues = [];
      this.isSubmitting = false;

      this.button.addEventListener('click', this.onButtonClick.bind(this));
      window.addEventListener('scroll', this.onScroll.bind(this));
      this.handleStickyClick = this.handleStickyClick.bind(this);
      window.addEventListener('cart:added', () => this.setSubmitting(false));
      window.addEventListener('cart:failed', () => this.setSubmitting(false));
      this.trackProgressInteractions();
      this.refresh();
      requestAnimationFrame(() => this.updateBuilderButtonHeight());
      this.observeStuckState();
      this.initQuantitySync();
      window.addEventListener('resize', ()=>this.updateContentFit());
      // Re-measure when the options column changes height after load (okendo stars,
      // lazy images, font swaps) — the initial measurement can run before hydration
      var contentFitBlocks = this.builder && this.builder.querySelector('.builder-blocks');
      if (contentFitBlocks && 'ResizeObserver' in window) {
        new ResizeObserver(()=>this.updateContentFit()).observe(contentFitBlocks);
      }
      this.initUnderPhotoBarRelease();
    }

    initUnderPhotoBarRelease() {
      // Mobile: the under-photo progress bar stays pinned beneath the sticky photo
      // while the shopper works through the options, then fades out once the Add to
      // Cart row has been scrolled past (and comes back when they scroll up).
      var bar = this.builder && this.builder.querySelector('.builder-progress-bar--under-photo');
      var btn = this.builder && this.builder.querySelector('.builder-button');
      if (!bar || !btn) return;
      var media = this.builder.querySelector('.main-product-media');
      // Pin to the photo's measured bottom — the 46svh CSS cap is a maximum, and
      // landscape galleries come up shorter, which left a gap content showed through
      var syncTop = ()=>{
        if (!media || !$s.media.isSmall) { bar.style.top = ''; return; }
        var headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-offset')) || 0;
        bar.style.top = (headerOffset + media.offsetHeight) + 'px';
      };
      syncTop();
      if (media && 'ResizeObserver' in window) {
        new ResizeObserver(syncTop).observe(media);
      }
      window.addEventListener('resize', syncTop);
      var ticking = false;
      var update = ()=>{
        ticking = false;
        var releasePoint = window.innerHeight * 0.46 + bar.offsetHeight + 40;
        bar.classList.toggle('released', btn.getBoundingClientRect().bottom < releasePoint);
      };
      window.addEventListener('scroll', ()=>{
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, {passive: true});
      update();
    }

    trackProgressInteractions() {
      // Progress reflects how many required steps currently have a valid selection
      // (preselected defaults included), so it starts ~70% and drops when a change leaves
      // a dependent step unselected. Defer to the next tick so stepsData is current.
      var update = () => setTimeout(() => this.updateProgressBar(), 0);
      this.builder.addEventListener('change', update);
      ['variantChange', 'mainVariantChange', 'stepChange', 'tiedProductVariantChange'].forEach((evt) => {
        this.builder.addEventListener(evt, update);
      });
      this.builder.addEventListener('click', (e) => {
        if (e.target.closest('.builder-reset')) update();
      });
    }

    initQuantitySync() {
      // The visible stepper (quantity block) drives the main bundle item's hidden
      // items[N][quantity] input — the form posts the items[] array, not "quantity".
      var qtyBox = this.builder.querySelector('.builder-qtty-atc.has-quantity-block quantity-input');
      if (!qtyBox) return;
      var qtyInput = qtyBox.querySelector('.quantity-input');
      var form = qtyBox.closest('form');
      if (!qtyInput || !form) return;
      var mainMarker = form.querySelector('input[name$="[properties[_bundle_item]]"][value="main"]');
      if (!mainMarker) return;
      var target = form.querySelector('input[name="' + mainMarker.name.replace('[properties[_bundle_item]]', '') + '[quantity]"]');
      if (!target) return;
      qtyInput.removeAttribute('name');
      var sync = function() { target.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); };
      qtyBox.addEventListener('change', sync);
      qtyBox.addEventListener('click', function() { setTimeout(sync, 0); });
      sync();
    }

    observeStuckState() {
      // Mobile test layout: the footer is position:sticky at the viewport bottom and shows a
      // compact Add to Cart while pinned, expanding (Shop Pay breakdown) once scrolled to its
      // natural position. is-stuck is only styled inside the test-formatting mobile media query.
      if (this.builder.dataset.testFormatting != 'true' || !('IntersectionObserver' in window)) return;
      var stickyParent = this.closest('.builder-button');
      if (!stickyParent) return;
      // Observe a zero-height sentinel at the button's natural flow position, NOT the button:
      // is-stuck hides the Shop Pay terms, which changes the button's height, so observing
      // the button feeds the observer its own side effect and it oscillates (the visible
      // Add-to-Cart "flashing" at the top of short single-variant pages).
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      stickyParent.parentNode.insertBefore(sentinel, stickyParent);
      new IntersectionObserver(function(entries) {
        stickyParent.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, {rootMargin: '0px 0px -1px 0px'}).observe(sentinel);
    }

    onScroll() {
      setTimeout(() => {
        if (this.parentNode.getBoundingClientRect().bottom <= 0) {
          this.classList.add('sticky');
          this.querySelector('.sticky-info').removeAttribute('aria-hidden');
          var productPrice = this.builder.querySelector('product-bundle-price');

          if (productPrice) {
            this.querySelector('.button-product-price').innerHTML = productPrice.innerHTML.replace('|', '');
          }
          this.addEventListener('click', this.handleStickyClick);
        } else {
          this.classList.remove('sticky');
          this.querySelector('.sticky-info').setAttribute('aria-hidden', true);
          this.removeEventListener('click', this.handleStickyClick);
        }
      }, 100);
    }

    handleStickyClick() {
      $s.scrollToElement(this.builder);
    }

    async onButtonClick(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if(this.isSubmitting) return;
      if(!this.validate()) return;

      this.setSubmitting(true);
      if(this.builder.previewCompositor && this.builder.previewCompositor.applyCartPreviewProperties) {
        this.builder.previewCompositor.applyCartPreviewProperties();
      }

      this.builder.addRecommendedProducts(()=>{
        var cartForm = this.builder.querySelector('add-to-cart-form');
        if(cartForm) cartForm.submit();
        setTimeout(() => this.setSubmitting(false), 8000);
      });
    }

    setSubmitting(isSubmitting) {
      this.isSubmitting = isSubmitting;
      this.button.toggleAttribute('aria-busy', isSubmitting);
      this.button.classList.toggle('loading', isSubmitting);
    }

    refresh() {
      var requiredBtn = this.querySelector('.btn.selection-required');
      this.missingValues = [];
      if(!this.builder.stepsData) {
        return;
      }
      if(this.feedbackMessage) {
        this.feedbackMessage.innerHTML = this.defaultFeedbackMessage;
        this.feedbackMessage.classList.add('hide');
      }
      this.builder.stepsData.forEach((step)=>{
          this.builder.querySelector(`[data-step="${step.step_number}"]`)?.classList.remove('error');
          this.builder.querySelector(`[data-step-nav="${step.step_number}"]`)?.classList.remove('error');
          if(step.values.length == 0 && !step.notRequired) {
            this.missingValues.push(step);
          }
          if(step.values.length > 0 && !step.notRequired) {
              step.values.forEach((value)=>{
                  if(!value.notRequired && value.value.length == 0 || value.value == 'Unselected') {
                    this.missingValues.push(step);
                  }
              });
          }
      })

      this.builder.querySelectorAll('tied-product').forEach((tiedProduct)=>{
        if(tiedProduct.getCurrentVariant() && tiedProduct.getCurrentVariant().available) {
          this.missingValues = this.missingValues.filter(x=>x!=tiedProduct);
        }
      });

      if (this.missingValues.length > 0) {
        this.querySelector('.btn').classList.add('disabled');
        this.querySelector('.feedback-msg-sticky').classList.remove('hide');
        if (requiredBtn) requiredBtn.style.display = 'none';
      }else {
        this.querySelector('.btn').classList.remove('disabled');
        if (requiredBtn) requiredBtn.style.display = 'none';
        this.querySelector('.feedback-msg-sticky').classList.add('hide');
        //this.feedbackMessage.classList.add('hide');
      }

      this.updateProgressBar();
      this.updateBuilderButtonHeight();
      this.updateContentFit();
    }

    updateContentFit() {
      // Desktop: when the options column is naturally SHORTER than the gallery beside
      // it, drop the flex stretch so the buy button sits directly under the last option.
      // Measure against the gallery column's height — a reference the toggle cannot
      // affect — NOT against the blocks' own clientHeight: once the flex cap is removed
      // clientHeight always equals content height, which latches the state and lets
      // tall columns (e.g. pressed-frame) overflow into the sections below.
      if (this.builder.classList.contains('is-quickview')) return;
      var blocks = this.builder.querySelector('.builder-blocks');
      var gallery = this.builder.querySelector('product-gallery');
      if (!blocks || !gallery) return;
      var galleryCol = gallery.closest('sticky-updown') || gallery;
      var btn = this.builder.querySelector('.builder-button');
      var contentHeight = blocks.scrollHeight + (btn ? btn.offsetHeight : 0);
      // 40px slack: post-load hydration (review stars etc.) grows the column slightly;
      // a near-fit should keep the button under the last option, not flip to scroll mode
      this.builder.classList.toggle('content-fits', contentHeight <= galleryCol.offsetHeight + 40);
    }

    updateProgressBar() {
      var bars = this.builder.querySelectorAll('.builder-progress-bar');
      if (!bars.length) return;
      // No steps at all (single-variant utility products on builder templates): a
      // progress bar would sit at 0% forever, so hide it instead of rendering it.
      var stepsData = this.builder.stepsData || [];
      var requiredSteps = stepsData.filter(s => !s.notRequired);
      var totalSteps = requiredSteps.length;
      bars.forEach((bar) => { bar.style.display = totalSteps > 0 ? '' : 'none'; });
      if (totalSteps === 0) return;
      // A step counts as complete when it currently has a real selected value (preselected
      // defaults included) — recomputed live, not just steps the visitor touched. This makes
      // a preselected build read ~70% on load and DROP when a change (e.g. switching Frame
      // Shape) leaves a dependent step unselected.
      var completed = requiredSteps.filter((step) => {
        if (!step.values || step.values.length === 0) return false;
        return step.values.every((v) => v.notRequired || (v.value && v.value.length > 0 && v.value !== 'Unselected'));
      }).length;
      var ratio = totalSteps > 0 ? completed / totalSteps : 0;
      bars.forEach((bar) => {
        // Snap to the nearest 10 so the bar always reads in clean tens (e.g. 70 -> 80 ->
        // 90 -> 100) rather than 1/Nth increments like 67/78/89.
        var pct = Math.round(ratio * 10) * 10;
        bar.querySelector('.builder-progress-bar__fill').style.width = pct + '%';
        bar.querySelector('.builder-progress-bar__label').textContent = pct + '%';
      });
    }

    updateBuilderButtonHeight() {
      var builderBtn = this.closest('.builder-button');
      if (builderBtn && this.builder) {
        this.builder.style.setProperty('--builder-btn-height', builderBtn.offsetHeight + 'px');
      }
    }

    validate() {
      this.refresh();

      if (this.missingValues.length > 0) {
        this.missingValues.forEach((step)=>{
          this.builder.querySelector(`[data-step="${step.step_number}"]`)?.classList.add('error');
          this.builder.querySelector(`[data-step-nav="${step.step_number}"]`)?.classList.add('error');
        });
        this.feedbackMessage.classList.remove('hide');

        var firstError = this.builder.querySelector(`.step[data-step="${this.missingValues[0].step_number}"]`);
        if (firstError) {
          // Align the first missing step to the top (scroll-margin-top clears the sticky
          // header/photo) instead of centering — centering clamped near-bottom steps like
          // Bloom Protection and Personalization under the sticky Add to Cart footer.
          firstError.scrollIntoView({behavior: "smooth", block: "start"});
        }

        return false;
      }

      var placeholderItems = this.getPlaceholderCartItems();
      if(placeholderItems.length > 0) {
        console.warn('[Builder validation] Placeholder variant ids are still selected', placeholderItems);
        this.feedbackMessage.innerHTML = 'Please select all required frame details before checkout.';
        this.feedbackMessage.classList.remove('hide');
        var firstMissingStep = placeholderItems[0].stepElement || this.builder;
        firstMissingStep.scrollIntoView({behavior: "smooth", block: "start"});
        return false;
      }

      // Components with conditional required fields (embroidery text, font, thread) own
      // their own rules: they return a message when the step is incomplete.
      var componentError = null;
      this.builder.querySelectorAll('[data-builder-validate]').forEach((component)=>{
        if(componentError || typeof component.validateForCheckout !== 'function') return;
        var message = component.validateForCheckout();
        if(message) componentError = {message, element: component};
      });
      if(componentError) {
        this.feedbackMessage.innerHTML = componentError.message;
        this.feedbackMessage.classList.remove('hide');
        var componentStep = componentError.element.closest('.step') || componentError.element;
        componentStep.classList.add('error');
        componentStep.scrollIntoView({behavior: "smooth", block: "start"});
        return false;
      }

      var previewMessage = this.builder.previewCompositor && this.builder.previewCompositor.getBlockingMessage
        ? this.builder.previewCompositor.getBlockingMessage()
        : '';

      if(previewMessage) {
        console.warn('[Builder preview] Preview metadata is incomplete, but checkout is still allowed.', previewMessage);
      }

      this.feedbackMessage.innerHTML = this.defaultFeedbackMessage;
      this.feedbackMessage.classList.add('hide');
      return true;
    }

    getPlaceholderCartItems() {
      var form = this.builder.querySelector('form');
      if(!form) return [];

      return Array.from(form.querySelectorAll('[name$="[id]"]')).filter(input => {
        if(input.closest('product-sticky-panel')) return false;
        return /^9{6,}/.test(String(input.value || ''));
      }).map(input => {
        var stepElement = input.closest('.step') || input.closest('tied-product')?.querySelector('.step') || this.builder.querySelector('.step');
        return {
          name: input.name,
          value: input.value,
          label: stepElement ? stepElement.querySelector('.option-title')?.textContent.trim() : '',
          step: stepElement ? stepElement.dataset.step : '',
          stepElement
        };
      });
    }

  }
  customElements.define('builder-buttons', BuilderButtons);
}

class ProductBundlePrice extends HTMLElement {
  constructor() {
    super();
    this.listenEvents = ['priceChange', 'bundleChange', 'mainVariantChange', 'tiedProductVariantChange'];
    this._initialized = false;
  }

  connectedCallback() {
    // Only initialize once
    if (this._initialized) return;
    this._initialized = true;

    this.mainElement = this.closest('product-main-builder');

    // If not found as ancestor, check if we're in the mobile header (builder-top-mobile)
    // which is a sibling of product-main-builder
    if (!this.mainElement) {
      const mobileHeader = this.closest('.builder-top-mobile');
      if (mobileHeader && mobileHeader.nextElementSibling) {
        this.mainElement = mobileHeader.nextElementSibling.matches('product-main-builder')
          ? mobileHeader.nextElementSibling
          : mobileHeader.parentNode.querySelector('product-main-builder');
      }
    }

    this.comparePrice = this.querySelector('.compare');
    this.finalPrice = this.querySelector('.final');
    this.bfPriceChanged = (value) => {
      const terms = this.mainElement?.querySelector('.payment-terms-below-cart shopify-payment-terms');
      const amount = terms?.shadowRoot?.querySelector('span.font-bold');
      if (amount) amount.textContent = $s.formatMoney(value / 4);
    };

    // Check if we're in deferred pricing mode (from own data attributes set in Liquid)
    // In deferred mode, show price_min until user explicitly selects a variant
    this.deferredPricing = this.dataset.deferredPricing === 'true';
    this.priceMin = this.dataset.priceMin ? parseInt(this.dataset.priceMin) : null;

    if (!this.mainElement) {
      console.warn('ProductBundlePrice: Could not find parent product-main-builder');
      return;
    }

    let mainPrice = 0;
    this.listenEvents.forEach((event)=>{
      this.mainElement.addEventListener(event, (e)=>{
      // Track when deferred pricing should end or restart
      if (event === 'mainVariantChange' && e.detail && e.detail.variant) {
        // If deferredPrice is explicitly false (user selected all options), end deferred pricing
        if (e.detail.deferredPrice === false) {
          this.deferredPricing = false;
          this.deferredDisplayPrice = null;
        }
        // If deferredPrice is true and we have a specific price in the event, store it
        // Only update if: no current display price, OR new price is higher than priceMin (size-specific)
        else if (e.detail.deferredPrice === true && e.detail.variant.price) {
          this.deferredPricing = true;
          // If resetDeferred flag is set, clear the display price to use priceMin
          if (e.detail.resetDeferred) {
            this.deferredDisplayPrice = null;
          }
          // Only update deferredDisplayPrice if new price is higher than priceMin
          // (indicates a size was selected, not just a cascade with default priceMin)
          else if (!this.deferredDisplayPrice || e.detail.variant.price > this.priceMin) {
            this.deferredDisplayPrice = e.detail.variant.price;
          }
        }
        // If undefined, keep current state (don't change)
      }

      // Get the current variant
      var currentVariant = this.mainElement.getCurrentVariant();

      // Determine which price to use
      if (this.deferredPricing && this.deferredDisplayPrice) {
        // Use the stored deferred display price (e.g., min price for selected size)
        mainPrice = this.deferredDisplayPrice;
      } else if (this.deferredPricing && this.priceMin) {
        // Deferred mode with no specific price - use priceMin
        mainPrice = this.priceMin;
      } else {
        // Normal mode - use current variant price
        mainPrice = currentVariant.price + (Number(this.dataset.bfExtra) || 0);
      }
      let totalPrice = mainPrice;
      const bfLines = window.BlackFriday ? window.BlackFriday.priceParts(this, mainPrice) : [];
      let isBundle = false;
      this.mainElement.querySelectorAll('[data-price]').forEach((el)=>{
        let quantityInput = el.querySelector('[name*="[quantity]"]');
        if (!quantityInput && el.dataset.manualSelected === 'true') {
          quantityInput = el.querySelector('.quantity-input');
        }
        if (!quantityInput) {
          return;
        }

        const quantity = Number(quantityInput.value) || 0;
        const linePrice = Number(el.dataset.price);

        if (!quantity || Number.isNaN(linePrice)) {
          return;
        }

        totalPrice += linePrice * quantity;
        if (window.BlackFriday) bfLines.push(...window.BlackFriday.priceParts(el, linePrice, quantity));
        isBundle = true;
      })

      const discountMultiplier = isBundle ? 1 - (this.dataset.discountPercentage||0)/100 : 1;

      // Apply tier discounts: $70 off $450+, $120 off $720+
      // let tierDiscount = 0;
      // if (totalPrice >= 72000) {
      //   tierDiscount = 12000; // $120 off
      // } else if (totalPrice >= 45000) {
      //   tierDiscount = 7000; // $70 off
      // }

      // Check if there's a compare-at price on the variant or a bundle discount
      var hasComparePrice = currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price;
      var hasBundleDiscount = discountMultiplier !== 1;
      // var hasTierDiscount = tierDiscount > 0;

      // if (hasComparePrice || hasBundleDiscount || hasTierDiscount) {
      if (hasComparePrice || hasBundleDiscount) {
        this.comparePrice.style.display = '';
        this.comparePrice.style.textDecoration = 'line-through';
        this.comparePrice.style.opacity = '0.6';
        // Show variant compare-at price if available, otherwise show bundle compare price
        if (hasComparePrice) {
          this.comparePrice.innerHTML = $s.formatMoney(currentVariant.compare_at_price).replace('.00', '');
        } else {
          this.comparePrice.innerHTML = $s.formatMoney(totalPrice).replace('.00', '');
        }
      } else {
        this.comparePrice.style.display = 'none';
      }

      // Calculate final price with all discounts
      // var finalPriceValue = (totalPrice * discountMultiplier) - tierDiscount;
      var finalPriceValue = (totalPrice * discountMultiplier);

      this.finalPrice.innerHTML = $s.formatMoney(finalPriceValue).replace('.00', '');
      window.BlackFriday?.update(this, totalPrice, bfLines, false, finalPriceValue);
      if (this.hasAttribute('data-bf-applied')) finalPriceValue = window.BlackFriday.discounted(bfLines);

      // Update Shop Pay installment amount (total / 4)
      var installmentAmount = finalPriceValue / 4;
      var shopifyPaymentTerms = this.mainElement.querySelector('.payment-terms-below-cart shopify-payment-terms');
      if (shopifyPaymentTerms && shopifyPaymentTerms.shadowRoot) {
        var priceSpan = shopifyPaymentTerms.shadowRoot.querySelector('span.font-bold');
        if (priceSpan) {
          priceSpan.textContent = $s.formatMoney(installmentAmount);
        }
      }

      if (isBundle) {
        this.classList.add('is-bundle');
      } else {
        this.classList.remove('is-bundle');
      }
    });
  });
}
}
customElements.define('product-bundle-price', ProductBundlePrice);

if(!customElements.get('gift-message')) {
class GiftMessage extends HTMLElement {
  constructor() {
    super();
    this.builder = this.closest('product-main-builder');
    this.messageInput = this.querySelector('textarea');
    this.messageLabel = this.querySelector('.gift-message-input label');
    this.requestInputs = this.querySelectorAll('[type="radio"]');
    this.isGift = false;
    this.customizationsAsCartNote = this.dataset.customizationsAsCartNote === 'true';
    this.testFormatting = this.builder && this.builder.dataset.testFormatting === 'true';

    this.messageInput.addEventListener('keyup', this.onMessageChange.bind(this));
    if (this.requestInputs) {
      this.requestInputs.forEach((input) => {
        input.addEventListener('change', this.onRequestChange.bind(this));
      })
      this.updateMessageInput([...this.requestInputs].find(input => input.checked));
    }
    // This line includes customizations as a cart note
    if (this.customizationsAsCartNote) {
      window.addEventListener('cart:added', event => {
        if(this.messageInput.value.length == 0) return;
        $s.post({
          type: 'POST',
          url: routes.cart_url + '/update.js',
          data: {
            note: `${(this.isGift) ? this.messageInput.dataset.giftNotesTitle : this.messageInput.dataset.notesTitle}: ${this.messageInput.value}`, dataType: 'json'
          }
        });
      })
    }
  }

  updateMessageInput(status) {
    this.messageInput.disabled = !status;
    this.messageLabel.classList.toggle('hide', !status);
    // Test formatting (Figma): the details question and field show before a
    // gift choice is made; typing without one falls to the default notes title
    if (this.testFormatting) {
      this.messageInput.disabled = false;
      this.messageLabel.classList.remove('hide');
    }

    if (status != lngg.product_main__builder__builder_is_gift_label) {
      this.messageInput.value = '';
      this.messageInput.setAttribute('data-required', false);
      this.messageLabel.textContent = lngg.product_main__builder__builder_not_gift_message_label;
      this.isGift = false;
    } else {
      this.messageInput.setAttribute('data-required', true);
      this.messageLabel.textContent = lngg.product_main__builder__builder_is_gift_message_label;
      this.isGift = true;
    }
  }

  onRequestChange(e) {
    this.updateMessageInput(e.target.value);
    this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
  }

  onMessageChange(e) {
    if(this.messageInput.value.length <= 0) {
      this.messageInput.removeAttribute('name');
      return;
    }
    this.messageInput.setAttribute('name', this.messageInput.dataset.name);
    this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
  }
}
customElements.define('gift-message', GiftMessage);

// Move gallery on mobile for quick view builder
function moveBuilderQuickViewGallery() {
  const isQuickView = document.querySelector('.product-quick-view product-main-builder.is-quickview');
  if (!isQuickView) return;

  const isMobile = window.innerWidth <= 608;
  if (!isMobile) return;

  const gallery = isQuickView.querySelector('.main-product-media');
  if (!gallery) return;

  let placeholder = isQuickView.querySelector('.builder-qv-mobile-gallery-placeholder');

  // Fallback: builders that show the price in the title header have no standalone
  // price block, so the placeholder (only rendered inside the price block) is never
  // output. Without it the gallery stays in its grid slot and the quick-view order
  // CSS drops it below the whole form. Create one right after the title/price so the
  // gallery lands near the top like the other builders.
  if (!placeholder) {
    const blocksContainer = isQuickView.querySelector('.builder-blocks')
      || isQuickView.querySelector('.main-product-info');
    if (!blocksContainer) return;

    placeholder = document.createElement('div');
    placeholder.className = 'builder-qv-mobile-gallery-placeholder';

    const priceEl = blocksContainer.querySelector('.module product-price');
    const anchor = (priceEl && priceEl.closest('.module'))
      || blocksContainer.querySelector('.product-title-wrapper');

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(placeholder, anchor.nextSibling);
    } else {
      blocksContainer.insertBefore(placeholder, blocksContainer.firstChild);
    }
  }

  if (placeholder && !placeholder.hasChildNodes()) {
    placeholder.appendChild(gallery);
    console.log('Builder quick view: Moved gallery to placeholder');
  }
}

// Run on load and when modal opens
document.addEventListener('DOMContentLoaded', moveBuilderQuickViewGallery);
window.addEventListener('load', moveBuilderQuickViewGallery);

// Watch for modal open
const modalObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach((node) => {
        if (node.classList && node.classList.contains('product-quick-view')) {
          setTimeout(moveBuilderQuickViewGallery, 100);
        }
      });
    }
  });
});

if (document.body) {
  modalObserver.observe(document.body, { childList: true, subtree: true });
}
}

// FAQ top buttons - scroll to FAQ section and open corresponding accordion
document.addEventListener('DOMContentLoaded', function() {
  const faqTopButtons = document.querySelectorAll('.faq-top-btn[data-faq-target]');

  faqTopButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const targetIndex = parseInt(this.getAttribute('data-faq-target'));
      const faqSection = document.querySelector('.product-faq-questions-section');

      if (faqSection) {
        const accordions = faqSection.querySelectorAll('.faq-question-item');
        const targetAccordion = accordions[targetIndex - 1];

        if (targetAccordion) {
          // Scroll to the accordion
          targetAccordion.scrollIntoView({ behavior: 'smooth', block: 'center' });

          // Wait for scroll, then open the accordion if not already open
          setTimeout(function() {
            const trigger = targetAccordion.querySelector('.accordion-trigger');
            if (trigger && trigger.getAttribute('aria-expanded') === 'false') {
              trigger.click();
            }
          }, 500);
        }
      }
    });
  });

  // Enable drag-to-scroll on FAQ top buttons wrapper
  const wrapper = document.querySelector('.faq-top-buttons-wrapper');
  if (wrapper) {
    let isDown = false;
    let startX;
    let scrollLeft;

    wrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      wrapper.style.cursor = 'grabbing';
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('mouseleave', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mouseup', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 2;
      wrapper.scrollLeft = scrollLeft - walk;
    });

    wrapper.style.cursor = 'grab';
  }
});
